var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g, _path72, _g2, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _g3, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _g4, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _g5, _path311, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 1832,
    viewBox: "0 0 1280 1832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_1533)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1832,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -62,
    y: -108,
    width: 1407,
    height: 1930,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 489.842H496.81V246.135H9.29456V489.842H171.8Z",
    fill: "#DCDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0824 1302.39H821.608V2.61084H9.0824V1302.39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 245.966H496.81V83.4941H171.8V245.966Z",
    fill: "#DCDCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 733.552H334.305V571.08H171.8V733.552Z",
    fill: "#DCDCDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 1058.5H821.82V733.552H659.315V1058.5Z",
    fill: "#DCDCDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 1058.5H171.8V896.024H9.29456V1058.5Z",
    fill: "#DCDCDC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 245.966H496.81C496.81 156.235 569.565 83.4941 659.315 83.4941V245.966Z",
    fill: "#F1F1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.316 237.681H651.029V91.9981C572.579 96.1738 509.492 159.247 505.316 237.681ZM667.602 254.252H488.52V245.966C488.52 151.807 565.14 75.209 659.315 75.209H667.602V254.252Z",
    fill: "#FFFFFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 1220.97H171.8V1058.5H9.29456V1220.97Z",
    fill: "#DCDCDC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29123 83.5273V245.963H496.81V2.25635L9.0824 2.28949V83.5273H9.29123Z",
    fill: "#EFEFEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3692 75.242L17.5781 83.5272V237.681L488.52 237.678V10.5381L17.3692 10.5746V75.242ZM9.29121 254.252H1.00436V91.8124H0.795532V-5.99577L505.094 -6.03223V254.248L9.29121 254.252Z",
    fill: "#FFFFFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 1220.97H821.82V1058.5H659.315V1220.97Z",
    fill: "#DCDCDC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 733.552H821.82V408.608H496.81V733.552H659.315Z",
    fill: "#DCDCDC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.094 725.267H813.534V416.893H505.094V725.267ZM488.52 741.838H830.107V400.323H488.52V741.838Z",
    fill: "#FFFFFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 408.608H821.82V246.135H496.81V408.608H659.315Z",
    fill: "#EFEFEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.094 400.322H813.534V254.42H505.094V400.322ZM488.52 416.893H830.107V237.85H488.52V416.893Z",
    fill: "#FFFFFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 454.759C595.162 454.759 542.968 506.943 542.968 571.083C542.968 635.224 595.162 687.404 659.315 687.404C723.465 687.404 775.659 635.224 775.659 571.083C775.659 506.943 723.465 454.759 659.315 454.759ZM659.315 694.032C591.506 694.032 536.338 638.879 536.338 571.083C536.338 503.287 591.506 448.131 659.315 448.131C727.125 448.131 782.289 503.287 782.289 571.083C782.289 638.879 727.125 694.032 659.315 694.032Z",
    fill: "#FFFFFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 471.065C604.151 471.065 559.276 515.934 559.276 571.083C559.276 626.233 604.151 671.099 659.315 671.099C714.476 671.099 759.354 626.233 759.354 571.083C759.354 515.934 714.476 471.065 659.315 471.065ZM659.315 677.727C600.499 677.727 552.647 629.888 552.647 571.083C552.647 512.278 600.499 464.437 659.315 464.437C718.132 464.437 765.984 512.278 765.984 571.083C765.984 629.888 718.132 677.727 659.315 677.727Z",
    fill: "#FFFFFE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 487.37C613.144 487.37 575.585 524.922 575.585 571.083C575.585 617.242 613.144 654.793 659.315 654.793C705.486 654.793 743.046 617.242 743.046 571.083C743.046 524.922 705.486 487.37 659.315 487.37ZM659.315 661.421C609.492 661.421 568.956 620.897 568.956 571.083C568.956 521.266 609.492 480.742 659.315 480.742C709.139 480.742 749.675 521.266 749.675 571.083C749.675 620.897 709.139 661.421 659.315 661.421Z",
    fill: "#FFFFFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 503.672C622.137 503.672 591.893 533.913 591.893 571.08C591.893 608.247 622.137 638.488 659.315 638.488C696.493 638.488 726.737 608.247 726.737 571.08C726.737 533.913 696.493 503.672 659.315 503.672ZM659.315 645.116C618.484 645.116 585.264 611.903 585.264 571.08C585.264 530.257 618.484 497.044 659.315 497.044C700.146 497.044 733.367 530.257 733.367 571.08C733.367 611.903 700.146 645.116 659.315 645.116Z",
    fill: "#FFFFFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 519.977C631.13 519.977 608.202 542.904 608.202 571.08C608.202 599.26 631.13 622.183 659.315 622.183C687.501 622.183 710.429 599.26 710.429 571.08C710.429 542.904 687.501 519.977 659.315 519.977ZM659.315 628.811C627.474 628.811 601.573 602.915 601.573 571.08C601.573 539.248 627.474 513.349 659.315 513.349C691.153 513.349 717.058 539.248 717.058 571.08C717.058 602.915 691.153 628.811 659.315 628.811Z",
    fill: "#FFFFFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 536.282C640.123 536.282 624.51 551.895 624.51 571.08C624.51 590.268 640.123 605.878 659.315 605.878C678.507 605.878 694.12 590.268 694.12 571.08C694.12 551.895 678.507 536.282 659.315 536.282ZM659.315 612.506C636.467 612.506 617.881 593.924 617.881 571.08C617.881 548.239 636.467 529.654 659.315 529.654C682.16 529.654 700.749 548.239 700.749 571.08C700.749 593.924 682.16 612.506 659.315 612.506Z",
    fill: "#FFFFFE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 552.587C649.116 552.587 640.819 560.882 640.819 571.08C640.819 581.277 649.116 589.572 659.315 589.572C669.515 589.572 677.811 581.277 677.811 571.08C677.811 560.882 669.515 552.587 659.315 552.587ZM659.315 596.201C645.46 596.201 634.189 584.933 634.189 571.08C634.189 557.227 645.46 545.959 659.315 545.959C673.171 545.959 684.441 557.227 684.441 571.08C684.441 584.933 673.171 596.201 659.315 596.201Z",
    fill: "#FFFFFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 896.025H496.81V571.08H171.8V896.025Z",
    fill: "#DCDCDC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.305 1220.97C424.055 1220.97 496.81 1148.23 496.81 1058.5V571.08H171.8V1058.5C171.8 1148.23 244.555 1220.97 334.305 1220.97Z",
    fill: "#FFF9F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.087 579.365V1058.5C180.087 1143.52 249.269 1212.68 334.305 1212.68C419.338 1212.68 488.52 1143.52 488.52 1058.5V579.365H180.087ZM334.305 1229.25C240.13 1229.25 163.513 1152.66 163.513 1058.5V562.795H505.094V1058.5C505.094 1152.66 428.48 1229.25 334.305 1229.25Z",
    fill: "#FFFFFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 891.474V884.846C255.238 884.846 323.124 816.977 323.124 733.552V571.08H329.754V733.552C329.754 820.63 258.895 891.474 171.8 891.474Z",
    fill: "#FFFFFE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 875.173V868.544C246.249 868.544 306.816 807.986 306.816 733.552V571.08H313.445V733.552C313.445 811.642 249.902 875.173 171.8 875.173Z",
    fill: "#FFFFFE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 858.867V852.239C237.256 852.239 290.507 798.995 290.507 733.552V571.08H297.137V733.552C297.137 802.651 240.909 858.867 171.8 858.867Z",
    fill: "#FFFFFE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 842.562V835.934C228.263 835.934 274.199 790.004 274.199 733.552V571.08H280.828V733.552C280.828 793.66 231.916 842.562 171.8 842.562Z",
    fill: "#FFFFFE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5454 571.08V733.552C90.5454 778.418 126.925 814.79 171.8 814.79C216.675 814.79 253.051 778.418 253.051 733.552V571.08H90.5454Z",
    fill: "#DCDCDC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8323 579.365V733.552C98.8323 773.779 131.565 806.505 171.8 806.505C212.031 806.505 244.764 773.779 244.764 733.552V579.365H98.8323ZM171.8 823.075C122.427 823.075 82.2585 782.915 82.2585 733.552V562.795H261.337V733.552C261.337 782.915 221.169 823.075 171.8 823.075Z",
    fill: "#FFFFFE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 652.318H90.5455V571.08H9.29456V652.318Z",
    fill: "#DCDCDC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 644.029H82.2586V579.365H17.5781V644.029ZM1.00439 660.6H98.8324V562.795H1.00439V660.6Z",
    fill: "#FFFFFE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 627.671C58.7438 627.671 65.897 620.519 65.897 611.697C65.897 602.875 58.7438 595.727 49.9199 595.727C41.0961 595.727 33.9429 602.875 33.9429 611.697C33.9429 620.519 41.0961 627.671 49.9199 627.671Z",
    fill: "#EFEFEF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 733.552H90.5455V652.318H9.29456V733.552Z",
    fill: "#EFEFEF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 725.267H82.2586V660.6H17.5781V725.267ZM1.00439 741.837H98.8324V644.029H1.00439V741.837Z",
    fill: "#FFFFFE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 708.909C58.7438 708.909 65.897 701.757 65.897 692.935C65.897 684.113 58.7438 676.961 49.9199 676.961C41.0961 676.961 33.9429 684.113 33.9429 692.935C33.9429 701.757 41.0961 708.909 49.9199 708.909Z",
    fill: "#FFEB36"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 571.08H90.5455V489.845H9.29456V571.08Z",
    fill: "#FFF9F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 562.795H82.2586V498.127H17.5781V562.795ZM1.00439 579.365H98.8324V481.557H1.00439V579.365Z",
    fill: "#FFFFFE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 546.436C58.7438 546.436 65.897 539.285 65.897 530.463C65.897 521.641 58.7438 514.489 49.9199 514.489C41.0961 514.489 33.9429 521.641 33.9429 530.463C33.9429 539.285 41.0961 546.436 49.9199 546.436Z",
    fill: "#EFEFEF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.064 814.79H659.315V733.556H578.064V814.79Z",
    fill: "#FFF9F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.348 806.508H651.028V741.841H586.348V806.508ZM569.774 823.079H667.602V725.271H569.774V823.079Z",
    fill: "#FFFFFE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.69 790.147C627.514 790.147 634.667 782.995 634.667 774.173C634.667 765.351 627.514 758.199 618.69 758.199C609.866 758.199 602.713 765.351 602.713 774.173C602.713 782.995 609.866 790.147 618.69 790.147Z",
    fill: "#DCDCDC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.81 814.79H578.064V733.556H496.81V814.79Z",
    fill: "#DCDCDC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.097 806.508H569.774V741.841H505.097V806.508ZM488.523 823.079H586.348V725.271H488.523V823.079Z",
    fill: "#FFFFFE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.436 790.147C546.26 790.147 553.413 782.995 553.413 774.173C553.413 765.351 546.26 758.199 537.436 758.199C528.615 758.199 521.462 765.351 521.462 774.173C521.462 782.995 528.615 790.147 537.436 790.147Z",
    fill: "#EFEFEF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.315 814.79H740.569V733.556H659.315V814.79Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.605 806.508H732.283V741.841H667.605V806.508ZM651.032 823.079H748.856V725.271H651.032V823.079Z",
    fill: "#FFFFFE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.944 790.147C708.768 790.147 715.918 782.995 715.918 774.173C715.918 765.351 708.768 758.199 699.944 758.199C691.12 758.199 683.967 765.351 683.967 774.173C683.967 782.995 691.12 790.147 699.944 790.147Z",
    fill: "#DCDCDC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.57 814.79H821.82V733.556H740.57V814.79Z",
    fill: "#EFEFEF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M748.856 806.508H813.534V741.841H748.856V806.508ZM732.283 823.079H830.107V725.271H732.283V823.079Z",
    fill: "#FFFFFE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.195 790.147C790.019 790.147 797.172 782.995 797.172 774.173C797.172 765.351 790.019 758.199 781.195 758.199C772.371 758.199 765.218 765.351 765.218 774.173C765.218 782.995 772.371 790.147 781.195 790.147Z",
    fill: "#DCDCDC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5454 571.08H171.8V489.845H90.5454V571.08Z",
    fill: "#1985E7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8357 562.795H163.513V498.127H98.8357V562.795ZM82.262 579.365H180.087V481.557H82.262V579.365Z",
    fill: "#FFFFFE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.174 546.436C139.998 546.436 147.148 539.285 147.148 530.463C147.148 521.641 139.998 514.489 131.174 514.489C122.35 514.489 115.197 521.641 115.197 530.463C115.197 539.285 122.35 546.436 131.174 546.436Z",
    fill: "#DCDCDC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.796 571.08H253.051V489.845H171.796V571.08Z",
    fill: "#FFF9F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.087 562.795H244.764V498.127H180.087V562.795ZM163.513 579.365H261.338V481.557H163.513V579.365Z",
    fill: "#FFFFFE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.425 546.436C221.249 546.436 228.399 539.285 228.399 530.463C228.399 521.641 221.249 514.489 212.425 514.489C203.601 514.489 196.448 521.641 196.448 530.463C196.448 539.285 203.601 546.436 212.425 546.436Z",
    fill: "#DCDCDC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.051 571.08H334.305V489.845H253.051V571.08Z",
    fill: "#DCDCDC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.337 562.795H326.018V498.127H261.337V562.795ZM244.764 579.365H342.592V481.557H244.764V579.365Z",
    fill: "#FFFFFE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.679 546.436C302.503 546.436 309.653 539.285 309.653 530.463C309.653 521.641 302.503 514.489 293.679 514.489C284.856 514.489 277.702 521.641 277.702 530.463C277.702 539.285 284.856 546.436 293.679 546.436Z",
    fill: "#FFF9F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.305 571.08V489.845C334.305 444.98 370.681 408.608 415.556 408.608C460.431 408.608 496.81 444.98 496.81 489.845V571.08H334.305Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.592 562.795H488.52V489.842C488.52 449.619 455.79 416.893 415.559 416.893C375.325 416.893 342.592 449.619 342.592 489.842V562.795ZM505.094 579.365H326.018V489.842C326.018 440.482 366.183 400.323 415.556 400.323C464.926 400.323 505.094 440.482 505.094 489.842V579.365Z",
    fill: "#FFFFFE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.305 1058.68H813.454V896.207H334.305V1058.68Z",
    fill: "#DCDCDC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.592 1050.4H805.17V904.492H342.592V1050.4ZM326.018 1066.97H821.744V887.922H326.018V1066.97Z",
    fill: "#FFFFFE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.8 977.445C171.8 932.579 208.176 896.207 253.051 896.207C297.926 896.207 334.305 932.579 334.305 977.445C334.305 1022.31 297.926 1058.68 253.051 1058.68C208.176 1058.68 171.8 1022.31 171.8 977.445Z",
    fill: "#EFEFEF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.051 904.492C212.82 904.492 180.087 937.218 180.087 977.445C180.087 1017.67 212.82 1050.4 253.051 1050.4C293.285 1050.4 326.018 1017.67 326.018 977.445C326.018 937.218 293.285 904.492 253.051 904.492ZM253.051 1066.97C203.681 1066.97 163.513 1026.8 163.513 977.445C163.513 928.082 203.681 887.922 253.051 887.922C302.424 887.922 342.592 928.082 342.592 977.445C342.592 1026.8 302.424 1066.97 253.051 1066.97Z",
    fill: "#FFFFFE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.81 246.135V408.608H659.315C659.315 318.876 586.56 246.135 496.81 246.135Z",
    fill: "#FFF9F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.094 400.322H650.806C646.633 321.888 583.544 258.815 505.094 254.639V400.322ZM667.602 416.893H488.52V237.85H496.807C590.985 237.85 667.602 314.452 667.602 408.608V416.893Z",
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1401_1533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 1154,
    width: 148,
    height: 149
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5488 1154.8H237.982V1302.21H90.5488V1154.8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1401_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1433.31V1426.68C171.843 1426.68 231.352 1367.18 231.352 1294.05C231.352 1220.93 171.843 1161.43 98.6998 1161.43H-71.9563V1154.8H98.6998C175.502 1154.8 237.982 1217.27 237.982 1294.05C237.982 1370.84 175.502 1433.31 98.6998 1433.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1417.01V1410.38C162.85 1410.38 215.044 1358.2 215.044 1294.05C215.044 1229.91 162.85 1177.73 98.6998 1177.73H-72.6127V1171.1H98.6998C166.509 1171.1 221.673 1226.26 221.673 1294.05C221.673 1361.85 166.509 1417.01 98.6998 1417.01Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1400.7V1394.07C153.86 1394.07 198.739 1349.21 198.739 1294.05C198.739 1238.9 153.86 1194.04 98.6998 1194.04H-71.9563V1187.41H98.6998C157.517 1187.41 205.368 1235.25 205.368 1294.05C205.368 1352.86 157.517 1400.7 98.6998 1400.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1384.4V1377.77C144.871 1377.77 182.43 1340.22 182.43 1294.05C182.43 1247.89 144.871 1210.34 98.6998 1210.34H-71.9563V1203.71H98.6998C148.524 1203.71 189.06 1244.24 189.06 1294.05C189.06 1343.87 148.524 1384.4 98.6998 1384.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1368.09V1361.46C135.878 1361.46 166.122 1331.23 166.122 1294.05C166.122 1256.88 135.878 1226.65 98.6998 1226.65H-71.9563V1220.02H98.6998C139.531 1220.02 172.751 1253.23 172.751 1294.05C172.751 1334.88 139.531 1368.09 98.6998 1368.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1351.79V1345.16C126.885 1345.16 149.813 1322.23 149.813 1294.05C149.813 1265.88 126.885 1242.95 98.6998 1242.95H-71.9563V1236.32H98.6998C130.538 1236.32 156.443 1262.22 156.443 1294.05C156.443 1325.89 130.538 1351.79 98.6998 1351.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1335.48V1328.85C117.892 1328.85 133.505 1313.24 133.505 1294.05C133.505 1274.87 117.892 1259.26 98.6998 1259.26H-71.9563V1252.63H98.6998C121.545 1252.63 140.134 1271.21 140.134 1294.05C140.134 1316.9 121.545 1335.48 98.6998 1335.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6998 1319.18V1312.55C108.899 1312.55 117.196 1304.25 117.196 1294.05C117.196 1283.86 108.899 1275.56 98.6998 1275.56H-71.9563V1268.93H98.6998C112.555 1268.93 123.826 1280.2 123.826 1294.05C123.826 1307.91 112.555 1319.18 98.6998 1319.18Z",
    fill: "#FFFFFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1401_1533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 83,
    width: 326,
    height: 163
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M334.305 245.966H496.81V83.4907H171.8V245.966H334.305Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1401_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 121.49C262.289 121.49 210.092 173.67 210.092 237.811C210.092 301.951 262.289 354.134 326.439 354.134C390.589 354.134 442.786 301.951 442.786 237.811C442.786 173.67 390.589 121.49 326.439 121.49ZM326.439 360.763C258.629 360.763 203.462 305.606 203.462 237.811C203.462 170.015 258.629 114.862 326.439 114.862C394.249 114.862 449.416 170.015 449.416 237.811C449.416 305.606 394.249 360.763 326.439 360.763Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 137.792C271.275 137.792 226.4 182.661 226.4 237.81C226.4 292.96 271.275 337.829 326.439 337.829C381.603 337.829 426.478 292.96 426.478 237.81C426.478 182.661 381.603 137.792 326.439 137.792ZM326.439 344.457C267.622 344.457 219.771 296.615 219.771 237.81C219.771 179.005 267.622 131.164 326.439 131.164C385.256 131.164 433.108 179.005 433.108 237.81C433.108 296.615 385.256 344.457 326.439 344.457Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 154.097C280.268 154.097 242.709 191.652 242.709 237.81C242.709 283.969 280.268 321.524 326.439 321.524C372.61 321.524 410.17 283.969 410.17 237.81C410.17 191.652 372.61 154.097 326.439 154.097ZM326.439 328.152C276.615 328.152 236.079 287.624 236.079 237.81C236.079 187.997 276.615 147.469 326.439 147.469C376.263 147.469 416.799 187.997 416.799 237.81C416.799 287.624 376.263 328.152 326.439 328.152Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 170.402C289.261 170.402 259.017 200.64 259.017 237.81C259.017 274.978 289.261 305.219 326.439 305.219C363.617 305.219 393.861 274.978 393.861 237.81C393.861 200.64 363.617 170.402 326.439 170.402ZM326.439 311.847C285.608 311.847 252.388 278.633 252.388 237.81C252.388 196.984 285.608 163.774 326.439 163.774C367.27 163.774 400.49 196.984 400.49 237.81C400.49 278.633 367.27 311.847 326.439 311.847Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 186.707C298.254 186.707 275.326 209.634 275.326 237.81C275.326 265.99 298.254 288.913 326.439 288.913C354.624 288.913 377.552 265.99 377.552 237.81C377.552 209.634 354.624 186.707 326.439 186.707ZM326.439 295.542C294.598 295.542 268.696 269.645 268.696 237.81C268.696 205.979 294.598 180.079 326.439 180.079C358.277 180.079 384.182 205.979 384.182 237.81C384.182 269.645 358.277 295.542 326.439 295.542Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 203.013C307.247 203.013 291.634 218.625 291.634 237.81C291.634 256.999 307.247 272.608 326.439 272.608C345.631 272.608 361.244 256.999 361.244 237.81C361.244 218.625 345.631 203.013 326.439 203.013ZM326.439 279.236C303.591 279.236 285.005 260.654 285.005 237.81C285.005 214.97 303.591 196.385 326.439 196.385C349.288 196.385 367.873 214.97 367.873 237.81C367.873 260.654 349.288 279.236 326.439 279.236Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.439 219.318C316.24 219.318 307.943 227.613 307.943 237.81C307.943 248.008 316.24 256.303 326.439 256.303C336.639 256.303 344.935 248.008 344.935 237.81C344.935 227.613 336.639 219.318 326.439 219.318ZM326.439 262.931C312.584 262.931 301.313 251.663 301.313 237.81C301.313 223.958 312.584 212.69 326.439 212.69C340.295 212.69 351.565 223.958 351.565 237.81C351.565 251.663 340.295 262.931 326.439 262.931Z",
    fill: "#FFFFFE"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.107 408.608H813.533V362.738H759.364V308.579H705.198V254.42H659.315V237.85H721.772V292.009H775.938V346.167H830.107V408.608Z",
    fill: "#FFFFFE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.602 1302.21H651.028V1256.33H596.859V1202.18H542.693V1148.02H475.012V1131.45H559.266V1185.6H613.433V1239.76H667.602V1302.21Z",
    fill: "#F9C756"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.002 173.014H90.5488V156.443H136.428V102.288H190.598V48.1263H244.764V2.25293H261.338V64.6966H207.171V118.859H153.002V173.014Z",
    fill: "#FFFFFE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 164.729H90.5455V83.4941H9.29456V164.729Z",
    fill: "#FBF7D1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 156.443H82.2586V91.7793H17.5781V156.443ZM1.00439 173.014H98.8324V75.209H1.00439V173.014Z",
    fill: "#FFFFFE"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 140.085C58.7438 140.085 65.897 132.933 65.897 124.111C65.897 115.289 58.7438 108.137 49.9199 108.137C41.0961 108.137 33.9429 115.289 33.9429 124.111C33.9429 132.933 41.0961 140.085 49.9199 140.085Z",
    fill: "#DCDCDC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 245.966H90.5455V164.729H9.29456V245.966Z",
    fill: "#FFF9F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 237.681H82.2586V173.014H17.5781V237.681ZM1.00439 254.252H98.8324V156.443H1.00439V254.252Z",
    fill: "#FFFFFE"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 221.32C58.7438 221.32 65.897 214.168 65.897 205.346C65.897 196.527 58.7438 189.375 49.9199 189.375C41.0961 189.375 33.9429 196.527 33.9429 205.346C33.9429 214.168 41.0961 221.32 49.9199 221.32Z",
    fill: "#DCDCDC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 83.4942H90.5455V2.25635H9.29456V83.4942Z",
    fill: "#EFEFEF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 75.209H82.2586V10.5415H17.5781V75.209ZM1.00439 91.7793H98.8324V-6.02881H1.00439V91.7793Z",
    fill: "#FFFFFE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 58.8474C58.7438 58.8474 65.897 51.6956 65.897 42.8736C65.897 34.0548 58.7438 26.9031 49.9199 26.9031C41.0961 26.9031 33.9429 34.0548 33.9429 42.8736C33.9429 51.6956 41.0961 58.8474 49.9199 58.8474Z",
    fill: "#054279"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 1220.97H90.5455V1139.73H9.29456V1220.97Z",
    fill: "#FFF9F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456 1298.24H537.25V1217H456V1298.24Z",
    fill: "#FFF9F5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361 1298.24H442.25V1217H361V1298.24Z",
    fill: "#EFEFEF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 1212.68H82.2586V1148.02H17.5781V1212.68ZM1.00439 1229.25H98.8324V1131.45H1.00439V1229.25Z",
    fill: "#FFFFFE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 1196.33C58.7438 1196.33 65.897 1189.17 65.897 1180.35C65.897 1171.53 58.7438 1164.38 49.9199 1164.38C41.0961 1164.38 33.9429 1171.53 33.9429 1180.35C33.9429 1189.17 41.0961 1196.33 49.9199 1196.33Z",
    fill: "#F9C756"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.625 1273.59C505.449 1273.59 512.602 1266.44 512.602 1257.62C512.602 1248.8 505.449 1241.64 496.625 1241.64C487.801 1241.64 480.648 1248.8 480.648 1257.62C480.648 1266.44 487.801 1273.59 496.625 1273.59Z",
    fill: "#F9C756"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.625 1273.59C410.449 1273.59 417.602 1266.44 417.602 1257.62C417.602 1248.8 410.449 1241.64 401.625 1241.64C392.801 1241.64 385.648 1248.8 385.648 1257.62C385.648 1266.44 392.801 1273.59 401.625 1273.59Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 1302.21H90.5455V1220.97H9.29456V1302.21Z",
    fill: "#DCDCDC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 1293.92H82.2586V1229.25H17.5781V1293.92ZM1.00439 1310.49H98.8324V1212.68H1.00439V1310.49Z",
    fill: "#FFFFFE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 1277.56C58.7438 1277.56 65.897 1270.41 65.897 1261.59C65.897 1252.76 58.7438 1245.62 49.9199 1245.62C41.0961 1245.62 33.9429 1252.76 33.9429 1261.59C33.9429 1270.41 41.0961 1277.56 49.9199 1277.56Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29456 1139.73H90.5455V1058.5H9.29456V1139.73Z",
    fill: "#DCDCDC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5781 1131.45H82.2586V1066.78H17.5781V1131.45ZM1.00439 1148.02H98.8324V1050.21H1.00439V1148.02Z",
    fill: "#FFFFFE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 1115.09C58.7438 1115.09 65.897 1107.94 65.897 1099.11C65.897 1090.29 58.7438 1083.14 49.9199 1083.14C41.0961 1083.14 33.9429 1090.29 33.9429 1099.11C33.9429 1107.94 41.0961 1115.09 49.9199 1115.09Z",
    fill: "#EFEFEF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.828 944.128C135.828 940.791 138.536 938.087 141.874 938.087C145.212 938.087 147.92 940.791 147.92 944.128C147.92 947.469 145.212 950.173 141.874 950.173C138.536 950.173 135.828 947.469 135.828 944.128Z",
    fill: "#054279"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.165 944.128C110.165 940.791 112.87 938.087 116.211 938.087C119.549 938.087 122.257 940.791 122.257 944.128C122.257 947.469 119.549 950.173 116.211 950.173C112.87 950.173 110.165 947.469 110.165 944.128Z",
    fill: "#054279"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5027 944.128C84.5027 940.791 87.2075 938.087 90.5488 938.087C93.8867 938.087 96.5949 940.791 96.5949 944.128C96.5949 947.469 93.8867 950.173 90.5488 950.173C87.2075 950.173 84.5027 947.469 84.5027 944.128Z",
    fill: "#054279"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8398 944.128C58.8398 940.791 61.5447 938.087 64.8859 938.087C68.2239 938.087 70.9287 940.791 70.9287 944.128C70.9287 947.469 68.2239 950.173 64.8859 950.173C61.5447 950.173 58.8398 947.469 58.8398 944.128Z",
    fill: "#054279"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1772 944.128C33.1772 940.791 35.8821 938.087 39.22 938.087C42.5613 938.087 45.2661 940.791 45.2661 944.128C45.2661 947.469 42.5613 950.173 39.22 950.173C35.8821 950.173 33.1772 947.469 33.1772 944.128Z",
    fill: "#054279"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.828 892.813C135.828 889.476 138.536 886.772 141.874 886.772C145.212 886.772 147.92 889.476 147.92 892.813C147.92 896.154 145.212 898.858 141.874 898.858C138.536 898.858 135.828 896.154 135.828 892.813Z",
    fill: "#054279"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.165 892.813C110.165 889.476 112.87 886.772 116.211 886.772C119.549 886.772 122.257 889.476 122.257 892.813C122.257 896.154 119.549 898.858 116.211 898.858C112.87 898.858 110.165 896.154 110.165 892.813Z",
    fill: "#054279"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5027 892.813C84.5027 889.476 87.2075 886.772 90.5488 886.772C93.8867 886.772 96.5949 889.476 96.5949 892.813C96.5949 896.154 93.8867 898.858 90.5488 898.858C87.2075 898.858 84.5027 896.154 84.5027 892.813Z",
    fill: "#054279"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8398 892.813C58.8398 889.476 61.5447 886.772 64.8859 886.772C68.2239 886.772 70.9287 889.476 70.9287 892.813C70.9287 896.154 68.2239 898.858 64.8859 898.858C61.5447 898.858 58.8398 896.154 58.8398 892.813Z",
    fill: "#054279"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1772 892.813C33.1772 889.476 35.8821 886.772 39.22 886.772C42.5613 886.772 45.2661 889.476 45.2661 892.813C45.2661 896.154 42.5613 898.858 39.22 898.858C35.8821 898.858 33.1772 896.154 33.1772 892.813Z",
    fill: "#054279"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.828 841.498C135.828 838.161 138.536 835.453 141.874 835.453C145.212 835.453 147.92 838.161 147.92 841.498C147.92 844.835 145.212 847.543 141.874 847.543C138.536 847.543 135.828 844.835 135.828 841.498Z",
    fill: "#FFFFFE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.165 841.498C110.165 838.161 112.87 835.453 116.211 835.453C119.549 835.453 122.257 838.161 122.257 841.498C122.257 844.835 119.549 847.543 116.211 847.543C112.87 847.543 110.165 844.835 110.165 841.498Z",
    fill: "#FFFFFE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5027 841.498C84.5027 838.161 87.2075 835.453 90.5488 835.453C93.8867 835.453 96.5949 838.161 96.5949 841.498C96.5949 844.835 93.8867 847.543 90.5488 847.543C87.2075 847.543 84.5027 844.835 84.5027 841.498Z",
    fill: "#FFFFFE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8398 841.498C58.8398 838.161 61.5447 835.453 64.8859 835.453C68.2239 835.453 70.9287 838.161 70.9287 841.498C70.9287 844.835 68.2239 847.543 64.8859 847.543C61.5447 847.543 58.8398 844.835 58.8398 841.498Z",
    fill: "#FFFFFE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1772 841.498C33.1772 838.161 35.8821 835.453 39.22 835.453C42.5613 835.453 45.2661 838.161 45.2661 841.498C45.2661 844.835 42.5613 847.543 39.22 847.543C35.8821 847.543 33.1772 844.835 33.1772 841.498Z",
    fill: "#FFFFFE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.828 867.156C135.828 863.818 138.536 861.111 141.874 861.111C145.212 861.111 147.92 863.818 147.92 867.156C147.92 870.493 145.212 873.201 141.874 873.201C138.536 873.201 135.828 870.493 135.828 867.156Z",
    fill: "#FFFFFE"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.165 867.156C110.165 863.818 112.87 861.111 116.211 861.111C119.549 861.111 122.257 863.818 122.257 867.156C122.257 870.493 119.549 873.201 116.211 873.201C112.87 873.201 110.165 870.493 110.165 867.156Z",
    fill: "#FFFFFE"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5027 867.156C84.5027 863.818 87.2075 861.111 90.5488 861.111C93.8867 861.111 96.5949 863.818 96.5949 867.156C96.5949 870.493 93.8867 873.201 90.5488 873.201C87.2075 873.201 84.5027 870.493 84.5027 867.156Z",
    fill: "#FFFFFE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8398 867.156C58.8398 863.818 61.5447 861.111 64.8859 861.111C68.2239 861.111 70.9287 863.818 70.9287 867.156C70.9287 870.493 68.2239 873.201 64.8859 873.201C61.5447 873.201 58.8398 870.493 58.8398 867.156Z",
    fill: "#FFFFFE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1772 867.156C33.1772 863.818 35.8821 861.111 39.22 861.111C42.5613 861.111 45.2661 863.818 45.2661 867.156C45.2661 870.493 42.5613 873.201 39.22 873.201C35.8821 873.201 33.1772 870.493 33.1772 867.156Z",
    fill: "#FFFFFE"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.828 918.471C135.828 915.133 138.536 912.429 141.874 912.429C145.212 912.429 147.92 915.133 147.92 918.471C147.92 921.811 145.212 924.516 141.874 924.516C138.536 924.516 135.828 921.811 135.828 918.471Z",
    fill: "#054279"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.165 918.471C110.165 915.133 112.87 912.429 116.211 912.429C119.549 912.429 122.257 915.133 122.257 918.471C122.257 921.811 119.549 924.516 116.211 924.516C112.87 924.516 110.165 921.811 110.165 918.471Z",
    fill: "#054279"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5027 918.471C84.5027 915.133 87.2075 912.429 90.5488 912.429C93.8867 912.429 96.5949 915.133 96.5949 918.471C96.5949 921.811 93.8867 924.516 90.5488 924.516C87.2075 924.516 84.5027 921.811 84.5027 918.471Z",
    fill: "#054279"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8398 918.471C58.8398 915.133 61.5447 912.429 64.8859 912.429C68.2239 912.429 70.9287 915.133 70.9287 918.471C70.9287 921.811 68.2239 924.516 64.8859 924.516C61.5447 924.516 58.8398 921.811 58.8398 918.471Z",
    fill: "#054279"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1772 918.471C33.1772 915.133 35.8821 912.429 39.22 912.429C42.5613 912.429 45.2661 915.133 45.2661 918.471C45.2661 921.811 42.5613 924.516 39.22 924.516C35.8821 924.516 33.1772 921.811 33.1772 918.471Z",
    fill: "#054279"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.355 1193.18C747.355 1189.84 750.063 1187.14 753.401 1187.14C756.739 1187.14 759.447 1189.84 759.447 1193.18C759.447 1196.52 756.739 1199.23 753.401 1199.23C750.063 1199.23 747.355 1196.52 747.355 1193.18Z",
    fill: "#FFFFFE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.692 1193.18C721.692 1189.84 724.4 1187.14 727.738 1187.14C731.076 1187.14 733.784 1189.84 733.784 1193.18C733.784 1196.52 731.076 1199.23 727.738 1199.23C724.4 1199.23 721.692 1196.52 721.692 1193.18Z",
    fill: "#FFFFFE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.355 1141.87C747.355 1138.53 750.063 1135.82 753.401 1135.82C756.739 1135.82 759.447 1138.53 759.447 1141.87C759.447 1145.2 756.739 1147.91 753.401 1147.91C750.063 1147.91 747.355 1145.2 747.355 1141.87Z",
    fill: "#FFFFFE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.692 1141.87C721.692 1138.53 724.4 1135.82 727.738 1135.82C731.076 1135.82 733.784 1138.53 733.784 1141.87C733.784 1145.2 731.076 1147.91 727.738 1147.91C724.4 1147.91 721.692 1145.2 721.692 1141.87Z",
    fill: "#FFFFFE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.355 1116.21C747.355 1112.87 750.063 1110.16 753.401 1110.16C756.739 1110.16 759.447 1112.87 759.447 1116.21C759.447 1119.55 756.739 1122.25 753.401 1122.25C750.063 1122.25 747.355 1119.55 747.355 1116.21Z",
    fill: "#FFFFFE"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.692 1116.21C721.692 1112.87 724.4 1110.16 727.738 1110.16C731.076 1110.16 733.784 1112.87 733.784 1116.21C733.784 1119.55 731.076 1122.25 727.738 1122.25C724.4 1122.25 721.692 1119.55 721.692 1116.21Z",
    fill: "#FFFFFE"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.355 1167.52C747.355 1164.18 750.063 1161.48 753.401 1161.48C756.739 1161.48 759.447 1164.18 759.447 1167.52C759.447 1170.86 756.739 1173.57 753.401 1173.57C750.063 1173.57 747.355 1170.86 747.355 1167.52Z",
    fill: "#FFFFFE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.692 1167.52C721.692 1164.18 724.4 1161.48 727.738 1161.48C731.076 1161.48 733.784 1164.18 733.784 1167.52C733.784 1170.86 731.076 1173.57 727.738 1173.57C724.4 1173.57 721.692 1170.86 721.692 1167.52Z",
    fill: "#FFFFFE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.355 1218.84C747.355 1215.5 750.063 1212.79 753.401 1212.79C756.739 1212.79 759.447 1215.5 759.447 1218.84C759.447 1222.18 756.739 1224.88 753.401 1224.88C750.063 1224.88 747.355 1222.18 747.355 1218.84Z",
    fill: "#FFFFFE"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.692 1218.84C721.692 1215.5 724.4 1212.79 727.738 1212.79C731.076 1212.79 733.784 1215.5 733.784 1218.84C733.784 1222.18 731.076 1224.88 727.738 1224.88C724.4 1224.88 721.692 1222.18 721.692 1218.84Z",
    fill: "#FFFFFE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.355 1244.5C747.355 1241.16 750.063 1238.45 753.401 1238.45C756.739 1238.45 759.447 1241.16 759.447 1244.5C759.447 1247.83 756.739 1250.54 753.401 1250.54C750.063 1250.54 747.355 1247.83 747.355 1244.5Z",
    fill: "#FFFFFE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.692 1244.5C721.692 1241.16 724.4 1238.45 727.738 1238.45C731.076 1238.45 733.784 1241.16 733.784 1244.5C733.784 1247.83 731.076 1250.54 727.738 1250.54C724.4 1250.54 721.692 1247.83 721.692 1244.5Z",
    fill: "#FFFFFE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6824 380.819C72.6824 377.479 75.3872 374.774 78.7285 374.774C82.0664 374.774 84.7712 377.479 84.7712 380.819C84.7712 384.157 82.0664 386.861 78.7285 386.861C75.3872 386.861 72.6824 384.157 72.6824 380.819Z",
    fill: "#FFFFFE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0195 380.819C47.0195 377.479 49.7244 374.774 53.0656 374.774C56.4036 374.774 59.1084 377.479 59.1084 380.819C59.1084 384.157 56.4036 386.861 53.0656 386.861C49.7244 386.861 47.0195 384.157 47.0195 380.819Z",
    fill: "#FFFFFE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6824 329.504C72.6824 326.164 75.3872 323.459 78.7285 323.459C82.0664 323.459 84.7712 326.164 84.7712 329.504C84.7712 332.841 82.0664 335.546 78.7285 335.546C75.3872 335.546 72.6824 332.841 72.6824 329.504Z",
    fill: "#FFFFFE"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0195 329.504C47.0195 326.164 49.7244 323.459 53.0656 323.459C56.4036 323.459 59.1084 326.164 59.1084 329.504C59.1084 332.841 56.4036 335.546 53.0656 335.546C49.7244 335.546 47.0195 332.841 47.0195 329.504Z",
    fill: "#FFFFFE"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6824 303.843C72.6824 300.506 75.3872 297.802 78.7285 297.802C82.0664 297.802 84.7712 300.506 84.7712 303.843C84.7712 307.184 82.0664 309.888 78.7285 309.888C75.3872 309.888 72.6824 307.184 72.6824 303.843Z",
    fill: "#FFFFFE"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0195 303.843C47.0195 300.506 49.7244 297.802 53.0656 297.802C56.4036 297.802 59.1084 300.506 59.1084 303.843C59.1084 307.184 56.4036 309.888 53.0656 309.888C49.7244 309.888 47.0195 307.184 47.0195 303.843Z",
    fill: "#FFFFFE"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6824 355.158C72.6824 351.821 75.3872 349.117 78.7285 349.117C82.0664 349.117 84.7712 351.821 84.7712 355.158C84.7712 358.499 82.0664 361.203 78.7285 361.203C75.3872 361.203 72.6824 358.499 72.6824 355.158Z",
    fill: "#FFFFFE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0195 355.158C47.0195 351.821 49.7244 349.117 53.0656 349.117C56.4036 349.117 59.1084 351.821 59.1084 355.158C59.1084 358.499 56.4036 361.203 53.0656 361.203C49.7244 361.203 47.0195 358.499 47.0195 355.158Z",
    fill: "#FFFFFE"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6824 406.477C72.6824 403.136 75.3872 400.432 78.7285 400.432C82.0664 400.432 84.7712 403.136 84.7712 406.477C84.7712 409.814 82.0664 412.518 78.7285 412.518C75.3872 412.518 72.6824 409.814 72.6824 406.477Z",
    fill: "#FFFFFE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0195 406.477C47.0195 403.136 49.7244 400.432 53.0656 400.432C56.4036 400.432 59.1084 403.136 59.1084 406.477C59.1084 409.814 56.4036 412.518 53.0656 412.518C49.7244 412.518 47.0195 409.814 47.0195 406.477Z",
    fill: "#FFFFFE"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6824 432.134C72.6824 428.797 75.3872 426.089 78.7285 426.089C82.0664 426.089 84.7712 428.797 84.7712 432.134C84.7712 435.472 82.0664 438.179 78.7285 438.179C75.3872 438.179 72.6824 435.472 72.6824 432.134Z",
    fill: "#FFFFFE"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0195 432.134C47.0195 428.797 49.7244 426.089 53.0656 426.089C56.4036 426.089 59.1084 428.797 59.1084 432.134C59.1084 435.472 56.4036 438.179 53.0656 438.179C49.7244 438.179 47.0195 435.472 47.0195 432.134Z",
    fill: "#FFFFFE"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.849 216.044C785.849 212.706 788.554 210.002 791.895 210.002C795.233 210.002 797.938 212.706 797.938 216.044C797.938 219.384 795.233 222.088 791.895 222.088C788.554 222.088 785.849 219.384 785.849 216.044Z",
    fill: "#FFFFFE"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.186 216.044C760.186 212.706 762.891 210.002 766.232 210.002C769.57 210.002 772.275 212.706 772.275 216.044C772.275 219.384 769.57 222.088 766.232 222.088C762.891 222.088 760.186 219.384 760.186 216.044Z",
    fill: "#FFFFFE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.523 216.044C734.523 212.706 737.228 210.002 740.566 210.002C743.907 210.002 746.612 212.706 746.612 216.044C746.612 219.384 743.907 222.088 740.566 222.088C737.228 222.088 734.523 219.384 734.523 216.044Z",
    fill: "#FFFFFE"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.861 216.044C708.861 212.706 711.565 210.002 714.903 210.002C718.245 210.002 720.949 212.706 720.949 216.044C720.949 219.384 718.245 222.088 714.903 222.088C711.565 222.088 708.861 219.384 708.861 216.044Z",
    fill: "#FFFFFE"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.195 216.044C683.195 212.706 685.903 210.002 689.241 210.002C692.582 210.002 695.287 212.706 695.287 216.044C695.287 219.384 692.582 222.088 689.241 222.088C685.903 222.088 683.195 219.384 683.195 216.044Z",
    fill: "#FFFFFE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.849 164.728C785.849 161.391 788.554 158.684 791.895 158.684C795.233 158.684 797.938 161.391 797.938 164.728C797.938 168.066 795.233 170.773 791.895 170.773C788.554 170.773 785.849 168.066 785.849 164.728Z",
    fill: "#FFFFFE"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.186 164.728C760.186 161.391 762.891 158.684 766.232 158.684C769.57 158.684 772.275 161.391 772.275 164.728C772.275 168.066 769.57 170.773 766.232 170.773C762.891 170.773 760.186 168.066 760.186 164.728Z",
    fill: "#FFFFFE"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.523 164.728C734.523 161.391 737.228 158.684 740.566 158.684C743.907 158.684 746.612 161.391 746.612 164.728C746.612 168.066 743.907 170.773 740.566 170.773C737.228 170.773 734.523 168.066 734.523 164.728Z",
    fill: "#FFFFFE"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.861 164.728C708.861 161.391 711.565 158.684 714.903 158.684C718.245 158.684 720.949 161.391 720.949 164.728C720.949 168.066 718.245 170.773 714.903 170.773C711.565 170.773 708.861 168.066 708.861 164.728Z",
    fill: "#FFFFFE"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.195 164.728C683.195 161.391 685.903 158.684 689.241 158.684C692.582 158.684 695.287 161.391 695.287 164.728C695.287 168.066 692.582 170.773 689.241 170.773C685.903 170.773 683.195 168.066 683.195 164.728Z",
    fill: "#FFFFFE"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.849 113.414C785.849 110.076 788.554 107.369 791.895 107.369C795.233 107.369 797.938 110.076 797.938 113.414C797.938 116.751 795.233 119.458 791.895 119.458C788.554 119.458 785.849 116.751 785.849 113.414Z",
    fill: "#FFFFFE"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.186 113.414C760.186 110.076 762.891 107.369 766.232 107.369C769.57 107.369 772.275 110.076 772.275 113.414C772.275 116.751 769.57 119.458 766.232 119.458C762.891 119.458 760.186 116.751 760.186 113.414Z",
    fill: "#FFFFFE"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.523 113.414C734.523 110.076 737.228 107.369 740.566 107.369C743.907 107.369 746.612 110.076 746.612 113.414C746.612 116.751 743.907 119.458 740.566 119.458C737.228 119.458 734.523 116.751 734.523 113.414Z",
    fill: "#FFFFFE"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.861 113.414C708.861 110.076 711.565 107.369 714.903 107.369C718.245 107.369 720.949 110.076 720.949 113.414C720.949 116.751 718.245 119.458 714.903 119.458C711.565 119.458 708.861 116.751 708.861 113.414Z",
    fill: "#FFFFFE"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.195 113.414C683.195 110.076 685.903 107.369 689.241 107.369C692.582 107.369 695.287 110.076 695.287 113.414C695.287 116.751 692.582 119.458 689.241 119.458C685.903 119.458 683.195 116.751 683.195 113.414Z",
    fill: "#FFFFFE"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.849 139.071C785.849 135.734 788.554 133.026 791.895 133.026C795.233 133.026 797.938 135.734 797.938 139.071C797.938 142.408 795.233 145.116 791.895 145.116C788.554 145.116 785.849 142.408 785.849 139.071Z",
    fill: "#FFFFFE"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.186 139.071C760.186 135.734 762.891 133.026 766.232 133.026C769.57 133.026 772.275 135.734 772.275 139.071C772.275 142.408 769.57 145.116 766.232 145.116C762.891 145.116 760.186 142.408 760.186 139.071Z",
    fill: "#FFFFFE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.523 139.071C734.523 135.734 737.228 133.026 740.566 133.026C743.907 133.026 746.612 135.734 746.612 139.071C746.612 142.408 743.907 145.116 740.566 145.116C737.228 145.116 734.523 142.408 734.523 139.071Z",
    fill: "#FFFFFE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.861 139.071C708.861 135.734 711.565 133.026 714.903 133.026C718.245 133.026 720.949 135.734 720.949 139.071C720.949 142.408 718.245 145.116 714.903 145.116C711.565 145.116 708.861 142.408 708.861 139.071Z",
    fill: "#FFFFFE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.195 139.071C683.195 135.734 685.903 133.026 689.241 133.026C692.582 133.026 695.287 135.734 695.287 139.071C695.287 142.408 692.582 145.116 689.241 145.116C685.903 145.116 683.195 142.408 683.195 139.071Z",
    fill: "#FFFFFE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.849 190.386C785.849 187.049 788.554 184.341 791.895 184.341C795.233 184.341 797.938 187.049 797.938 190.386C797.938 193.723 795.233 196.431 791.895 196.431C788.554 196.431 785.849 193.723 785.849 190.386Z",
    fill: "#FFFFFE"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.186 190.386C760.186 187.049 762.891 184.341 766.232 184.341C769.57 184.341 772.275 187.049 772.275 190.386C772.275 193.723 769.57 196.431 766.232 196.431C762.891 196.431 760.186 193.723 760.186 190.386Z",
    fill: "#FFFFFE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.523 190.386C734.523 187.049 737.228 184.341 740.566 184.341C743.907 184.341 746.612 187.049 746.612 190.386C746.612 193.723 743.907 196.431 740.566 196.431C737.228 196.431 734.523 193.723 734.523 190.386Z",
    fill: "#FFFFFE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.861 190.386C708.861 187.049 711.565 184.341 714.903 184.341C718.245 184.341 720.949 187.049 720.949 190.386C720.949 193.723 718.245 196.431 714.903 196.431C711.565 196.431 708.861 193.723 708.861 190.386Z",
    fill: "#FFFFFE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.195 190.386C683.195 187.049 685.903 184.341 689.241 184.341C692.582 184.341 695.287 187.049 695.287 190.386C695.287 193.723 692.582 196.431 689.241 196.431C685.903 196.431 683.195 193.723 683.195 190.386Z",
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1401_1533)"
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.918 1302.61L10.3917 1302.61L10.3916 2602.39L822.917 2602.39L822.918 1302.61Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.685 1546.5L10.1797 1546.5L10.1797 1871.45L172.685 1871.45L172.685 1546.5Z",
    fill: "#DCDCDC"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.705 1546.5L660.2 1546.5L660.2 1708.98L822.705 1708.98L822.705 1546.5Z",
    fill: "#DCDCDC"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.705 1384.03L660.2 1384.03L660.2 1546.5L822.705 1546.5L822.705 1384.03Z",
    fill: "#DCDCDC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.685 1384.03L10.1797 1384.03L10.1797 1546.5L172.685 1546.5L172.685 1384.03Z",
    fill: "#DCDCDC"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.2 1708.98L335.19 1708.98L335.19 2033.92L660.2 2033.92L660.2 1708.98Z",
    fill: "#DCDCDC"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.695 1384.03C407.945 1384.03 335.19 1456.77 335.19 1546.5L335.19 2033.92L660.2 2033.92L660.2 1546.5C660.2 1456.77 587.445 1384.03 497.695 1384.03Z",
    fill: "#FFF9F5"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.913 2025.63L651.913 1546.5C651.913 1461.48 582.731 1392.32 497.695 1392.32C412.662 1392.32 343.48 1461.48 343.48 1546.5L343.48 2025.63L651.913 2025.63ZM497.695 1375.75C591.87 1375.75 668.487 1452.34 668.487 1546.5L668.487 2042.21L326.906 2042.21L326.906 1546.5C326.906 1452.34 403.52 1375.75 497.695 1375.75Z",
    fill: "#FFFFFE"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.2 1713.53L660.2 1720.15C576.762 1720.15 508.876 1788.02 508.876 1871.45L508.876 2033.92L502.246 2033.92L502.246 1871.45C502.246 1784.37 573.105 1713.53 660.2 1713.53Z",
    fill: "#FFFFFE"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.2 1729.83L660.2 1736.46C585.751 1736.46 525.184 1797.01 525.184 1871.45L525.184 2033.92L518.555 2033.92L518.555 1871.45C518.555 1793.36 582.098 1729.83 660.2 1729.83Z",
    fill: "#FFFFFE"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.2 1746.13L660.2 1752.76C594.744 1752.76 541.493 1806 541.493 1871.45L541.493 2033.92L534.863 2033.92L534.863 1871.45C534.863 1802.35 591.091 1746.13 660.2 1746.13Z",
    fill: "#FFFFFE"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.2 1762.44L660.2 1769.07C603.737 1769.07 557.801 1815 557.801 1871.45L557.801 2033.92L551.172 2033.92L551.172 1871.45C551.172 1811.34 600.084 1762.44 660.2 1762.44Z",
    fill: "#FFFFFE"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.455 2033.92L741.455 1871.45C741.455 1826.58 705.075 1790.21 660.2 1790.21C615.325 1790.21 578.949 1826.58 578.949 1871.45L578.949 2033.92L741.455 2033.92Z",
    fill: "#DCDCDC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.168 2025.63L733.168 1871.45C733.168 1831.22 700.434 1798.5 660.2 1798.5C619.969 1798.5 587.236 1831.22 587.236 1871.45L587.236 2025.63L733.168 2025.63ZM660.2 1781.92C709.573 1781.92 749.741 1822.08 749.741 1871.45L749.741 2042.21L570.662 2042.21L570.662 1871.45C570.662 1822.08 610.83 1781.92 660.2 1781.92Z",
    fill: "#FFFFFE"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.936 1790.21L172.685 1790.21L172.685 1871.44L253.936 1871.44L253.936 1790.21Z",
    fill: "#FFF9F5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.652 1798.49L180.972 1798.49L180.972 1863.16L245.652 1863.16L245.652 1798.49ZM262.226 1781.92L164.398 1781.92L164.398 1879.73L262.226 1879.73L262.226 1781.92Z",
    fill: "#FFFFFE"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.31 1814.85C204.486 1814.85 197.333 1822.01 197.333 1830.83C197.333 1839.65 204.486 1846.8 213.31 1846.8C222.134 1846.8 229.287 1839.65 229.287 1830.83C229.287 1822.01 222.134 1814.85 213.31 1814.85Z",
    fill: "#DCDCDC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.19 1790.21L253.936 1790.21L253.936 1871.44L335.19 1871.44L335.19 1790.21Z",
    fill: "#DCDCDC"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.903 1798.49L262.226 1798.49L262.226 1863.16L326.903 1863.16L326.903 1798.49ZM343.477 1781.92L245.652 1781.92L245.652 1879.73L343.477 1879.73L343.477 1781.92Z",
    fill: "#FFFFFE"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.564 1814.85C285.74 1814.85 278.587 1822.01 278.587 1830.83C278.587 1839.65 285.74 1846.8 294.564 1846.8C303.385 1846.8 310.538 1839.65 310.538 1830.83C310.538 1822.01 303.385 1814.85 294.564 1814.85Z",
    fill: "#EFEFEF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.685 1790.21L91.4305 1790.21L91.4305 1871.44L172.685 1871.44L172.685 1790.21Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.395 1798.49L99.7173 1798.49L99.7173 1863.16L164.395 1863.16L164.395 1798.49ZM180.968 1781.92L83.1436 1781.92L83.1436 1879.73L180.968 1879.73L180.968 1781.92Z",
    fill: "#FFFFFE"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.056 1814.85C123.232 1814.85 116.082 1822.01 116.082 1830.83C116.082 1839.65 123.232 1846.8 132.056 1846.8C140.88 1846.8 148.033 1839.65 148.033 1830.83C148.033 1822.01 140.88 1814.85 132.056 1814.85Z",
    fill: "#DCDCDC"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4304 1790.21L10.1796 1790.21L10.1796 1871.44L91.4304 1871.44L91.4304 1790.21Z",
    fill: "#EFEFEF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1436 1798.49L18.4664 1798.49L18.4664 1863.16L83.1436 1863.16L83.1436 1798.49ZM99.7173 1781.92L1.89271 1781.92L1.8927 1879.73L99.7173 1879.73L99.7173 1781.92Z",
    fill: "#FFFFFE"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.805 1814.85C41.9811 1814.85 34.8279 1822.01 34.8279 1830.83C34.8279 1839.65 41.9811 1846.8 50.805 1846.8C59.6288 1846.8 66.782 1839.65 66.782 1830.83C66.782 1822.01 59.6288 1814.85 50.805 1814.85Z",
    fill: "#DCDCDC"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.695 1546.32L18.546 1546.32L18.546 1708.79L497.695 1708.79L497.695 1546.32Z",
    fill: "#DCDCDC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.408 1554.6L26.8295 1554.6L26.8295 1700.51L489.408 1700.51L489.408 1554.6ZM505.982 1538.03L10.2558 1538.03L10.2558 1717.08L505.982 1717.08L505.982 1538.03Z",
    fill: "#FFFFFE"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.2 1627.56C660.2 1672.42 623.824 1708.79 578.949 1708.79C534.074 1708.79 497.695 1672.42 497.695 1627.56C497.695 1582.69 534.074 1546.32 578.949 1546.32C623.824 1546.32 660.2 1582.69 660.2 1627.56Z",
    fill: "#EFEFEF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.949 1700.51C619.18 1700.51 651.913 1667.78 651.913 1627.56C651.913 1587.33 619.18 1554.6 578.949 1554.6C538.715 1554.6 505.982 1587.33 505.982 1627.56C505.982 1667.78 538.715 1700.51 578.949 1700.51ZM578.949 1538.03C628.319 1538.03 668.487 1578.2 668.487 1627.56C668.487 1676.92 628.319 1717.08 578.949 1717.08C529.576 1717.08 489.408 1676.92 489.408 1627.56C489.408 1578.2 529.576 1538.03 578.949 1538.03Z",
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1401_1533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 594,
    y: 1302,
    width: 148,
    height: 149
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M741.451 1450.2L594.018 1450.2L594.018 1302.79L741.451 1302.79L741.451 1450.2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1401_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1171.69L733.3 1178.32C660.157 1178.32 600.648 1237.82 600.648 1310.95C600.648 1384.07 660.157 1443.57 733.3 1443.57L903.956 1443.57L903.956 1450.2L733.3 1450.2C656.498 1450.2 594.018 1387.73 594.018 1310.95C594.018 1234.16 656.498 1171.69 733.3 1171.69Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1187.99L733.3 1194.62C669.15 1194.62 616.956 1246.81 616.956 1310.95C616.956 1375.09 669.15 1427.27 733.3 1427.27L904.613 1427.27L904.613 1433.9L733.3 1433.9C665.49 1433.9 610.327 1378.74 610.327 1310.95C610.327 1243.15 665.49 1187.99 733.3 1187.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1204.3L733.3 1210.93C678.14 1210.93 633.261 1255.79 633.261 1310.95C633.261 1366.1 678.14 1410.96 733.3 1410.96L903.956 1410.96L903.956 1417.59L733.3 1417.59C674.483 1417.59 626.632 1369.75 626.632 1310.95C626.632 1252.14 674.483 1204.3 733.3 1204.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1220.6L733.3 1227.23C687.129 1227.23 649.57 1264.78 649.57 1310.95C649.57 1357.11 687.129 1394.66 733.3 1394.66L903.956 1394.66L903.956 1401.29L733.3 1401.29C683.476 1401.29 642.94 1360.76 642.94 1310.95C642.94 1261.13 683.476 1220.6 733.3 1220.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1236.91L733.3 1243.54C696.122 1243.54 665.878 1273.78 665.878 1310.95C665.878 1348.12 696.122 1378.35 733.3 1378.35L903.956 1378.35L903.956 1384.98L733.3 1384.98C692.469 1384.98 659.249 1351.77 659.249 1310.95C659.249 1270.12 692.469 1236.91 733.3 1236.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1253.21L733.3 1259.84C705.115 1259.84 682.187 1282.77 682.187 1310.95C682.187 1339.13 705.115 1362.05 733.3 1362.05L903.956 1362.05L903.956 1368.68L733.3 1368.68C701.462 1368.68 675.557 1342.78 675.557 1310.95C675.557 1279.11 701.462 1253.21 733.3 1253.21Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1269.52L733.3 1276.15C714.108 1276.15 698.495 1291.76 698.495 1310.95C698.495 1330.13 714.108 1345.74 733.3 1345.74L903.956 1345.74L903.956 1352.37L733.3 1352.37C710.455 1352.37 691.866 1333.79 691.866 1310.95C691.866 1288.1 710.455 1269.52 733.3 1269.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.3 1285.83L733.3 1292.45C723.101 1292.45 714.804 1300.75 714.804 1310.95C714.804 1321.14 723.101 1329.44 733.3 1329.44L903.956 1329.44L903.956 1336.07L733.3 1336.07C719.445 1336.07 708.174 1324.8 708.174 1310.95C708.174 1297.09 719.445 1285.83 733.3 1285.83Z",
    fill: "#FFFFFE"
  }))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.398 1302.79L180.971 1302.79L180.971 1348.67L235.141 1348.67L235.141 1402.82L289.307 1402.82L289.307 1456.98L356.988 1456.98L356.988 1473.55L272.733 1473.55L272.733 1419.4L218.567 1419.4L218.567 1365.24L164.398 1365.24L164.398 1302.79Z",
    fill: "#F9C756"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.706 1384.03L741.455 1384.03L741.455 1465.27L822.706 1465.27L822.706 1384.03Z",
    fill: "#FFF9F5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376 1306.76L294.749 1306.76L294.749 1388L376 1388L376 1306.76Z",
    fill: "#FFF9F5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471 1306.76L389.749 1306.76L389.749 1388L471 1388L471 1306.76Z",
    fill: "#EFEFEF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.422 1392.32L749.741 1392.32L749.741 1456.98L814.422 1456.98L814.422 1392.32ZM830.996 1375.75L733.168 1375.75L733.168 1473.55L830.996 1473.55L830.996 1375.75Z",
    fill: "#FFFFFE"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.08 1408.67C773.256 1408.67 766.103 1415.83 766.103 1424.65C766.103 1433.47 773.256 1440.62 782.08 1440.62C790.904 1440.62 798.057 1433.47 798.057 1424.65C798.057 1415.83 790.904 1408.67 782.08 1408.67Z",
    fill: "#F9C756"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.375 1331.41C326.551 1331.41 319.398 1338.56 319.398 1347.38C319.398 1356.2 326.551 1363.36 335.375 1363.36C344.199 1363.36 351.352 1356.2 351.352 1347.38C351.352 1338.56 344.199 1331.41 335.375 1331.41Z",
    fill: "#F9C756"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.375 1331.41C421.551 1331.41 414.398 1338.56 414.398 1347.38C414.398 1356.2 421.551 1363.36 430.375 1363.36C439.199 1363.36 446.352 1356.2 446.352 1347.38C446.352 1338.56 439.199 1331.41 430.375 1331.41Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.706 1302.79L741.455 1302.79L741.455 1384.03L822.706 1384.03L822.706 1302.79Z",
    fill: "#DCDCDC"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.422 1311.08L749.741 1311.08L749.741 1375.75L814.422 1375.75L814.422 1311.08ZM830.996 1294.51L733.168 1294.51L733.168 1392.32L830.996 1392.32L830.996 1294.51Z",
    fill: "#FFFFFE"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.08 1327.44C773.256 1327.44 766.103 1334.59 766.103 1343.41C766.103 1352.24 773.256 1359.38 782.08 1359.38C790.904 1359.38 798.057 1352.24 798.057 1343.41C798.057 1334.59 790.904 1327.44 782.08 1327.44Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.705 1465.27L741.454 1465.27L741.454 1546.5L822.705 1546.5L822.705 1465.27Z",
    fill: "#DCDCDC"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.422 1473.55L749.741 1473.55L749.741 1538.22L814.422 1538.22L814.422 1473.55ZM830.996 1456.98L733.168 1456.98L733.168 1554.79L830.996 1554.79L830.996 1456.98Z",
    fill: "#FFFFFE"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.08 1489.91C773.256 1489.91 766.103 1497.06 766.103 1505.89C766.103 1514.71 773.256 1521.86 782.08 1521.86C790.904 1521.86 798.057 1514.71 798.057 1505.89C798.057 1497.06 790.904 1489.91 782.08 1489.91Z",
    fill: "#EFEFEF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696.172 1660.87C696.172 1664.21 693.464 1666.91 690.126 1666.91C686.788 1666.91 684.08 1664.21 684.08 1660.87C684.08 1657.53 686.788 1654.83 690.126 1654.83C693.464 1654.83 696.172 1657.53 696.172 1660.87Z",
    fill: "#054279"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6453 1411.82C84.6453 1415.16 81.9371 1417.86 78.5991 1417.86C75.2612 1417.86 72.553 1415.16 72.553 1411.82C72.553 1408.48 75.2612 1405.77 78.5991 1405.77C81.9371 1405.77 84.6453 1408.48 84.6453 1411.82Z",
    fill: "#F9C756"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.308 1411.82C110.308 1415.16 107.6 1417.86 104.262 1417.86C100.924 1417.86 98.2156 1415.16 98.2156 1411.82C98.2156 1408.48 100.924 1405.77 104.262 1405.77C107.6 1405.77 110.308 1408.48 110.308 1411.82Z",
    fill: "#F9C756"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6453 1463.13C84.6453 1466.47 81.9371 1469.18 78.5991 1469.18C75.2612 1469.18 72.553 1466.47 72.553 1463.13C72.553 1459.8 75.2612 1457.09 78.5991 1457.09C81.9371 1457.09 84.6453 1459.8 84.6453 1463.13Z",
    fill: "#F9C756"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.308 1463.13C110.308 1466.47 107.6 1469.18 104.262 1469.18C100.924 1469.18 98.2156 1466.47 98.2156 1463.13C98.2156 1459.8 100.924 1457.09 104.262 1457.09C107.6 1457.09 110.308 1459.8 110.308 1463.13Z",
    fill: "#F9C756"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6453 1488.79C84.6453 1492.13 81.9371 1494.84 78.5991 1494.84C75.2612 1494.84 72.553 1492.13 72.553 1488.79C72.553 1485.45 75.2612 1482.75 78.5991 1482.75C81.9371 1482.75 84.6453 1485.45 84.6453 1488.79Z",
    fill: "#F9C756"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.308 1488.79C110.308 1492.13 107.6 1494.84 104.262 1494.84C100.924 1494.84 98.2156 1492.13 98.2156 1488.79C98.2156 1485.45 100.924 1482.75 104.262 1482.75C107.6 1482.75 110.308 1485.45 110.308 1488.79Z",
    fill: "#F9C756"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6453 1437.48C84.6453 1440.82 81.9371 1443.52 78.5991 1443.52C75.2612 1443.52 72.553 1440.82 72.553 1437.48C72.553 1434.14 75.2612 1431.43 78.5991 1431.43C81.9371 1431.43 84.6453 1434.14 84.6453 1437.48Z",
    fill: "#F9C756"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.308 1437.48C110.308 1440.82 107.6 1443.52 104.262 1443.52C100.924 1443.52 98.2156 1440.82 98.2156 1437.48C98.2156 1434.14 100.924 1431.43 104.262 1431.43C107.6 1431.43 110.308 1434.14 110.308 1437.48Z",
    fill: "#F9C756"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6453 1386.16C84.6453 1389.5 81.9371 1392.21 78.5991 1392.21C75.2612 1392.21 72.553 1389.5 72.553 1386.16C72.553 1382.82 75.2612 1380.12 78.5991 1380.12C81.9371 1380.12 84.6453 1382.82 84.6453 1386.16Z",
    fill: "#F9C756"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.308 1386.16C110.308 1389.5 107.6 1392.21 104.262 1392.21C100.924 1392.21 98.2156 1389.5 98.2156 1386.16C98.2156 1382.82 100.924 1380.12 104.262 1380.12C107.6 1380.12 110.308 1382.82 110.308 1386.16Z",
    fill: "#F9C756"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6453 1360.5C84.6453 1363.84 81.9371 1366.55 78.5991 1366.55C75.2612 1366.55 72.553 1363.84 72.553 1360.5C72.553 1357.17 75.2612 1354.46 78.5991 1354.46C81.9371 1354.46 84.6453 1357.17 84.6453 1360.5Z",
    fill: "#FFFFFE"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.308 1360.5C110.308 1363.84 107.6 1366.55 104.262 1366.55C100.924 1366.55 98.2156 1363.84 98.2156 1360.5C98.2156 1357.17 100.924 1354.46 104.262 1354.46C107.6 1354.46 110.308 1357.17 110.308 1360.5Z",
    fill: "#FFFFFE"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1401_1533)"
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1490.2 815.158L1165.19 815.158L1165.19 1058.86L1652.71 1058.86L1652.71 815.158L1490.2 815.158Z",
    fill: "#DCDCDC"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1652.92 2.61087L840.392 2.6108L840.392 1302.39L1652.92 1302.39L1652.92 2.61087Z",
    fill: "#DCDCDC"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1490.2 1059.03L1165.19 1059.03L1165.19 1221.51L1490.2 1221.51L1490.2 1059.03Z",
    fill: "#DCDCDC"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 246.503L840.18 246.503L840.18 571.448L1002.68 571.448L1002.68 246.503Z",
    fill: "#DCDCDC"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 1059.03L1165.19 1059.03C1165.19 1148.77 1092.43 1221.51 1002.68 1221.51L1002.68 1059.03Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.68 1067.32L1010.97 1067.32L1010.97 1213C1089.42 1208.83 1152.51 1145.75 1156.68 1067.32ZM994.398 1050.75L1173.48 1050.75L1173.48 1059.03C1173.48 1153.19 1096.86 1229.79 1002.68 1229.79L994.398 1229.79L994.398 1050.75Z",
    fill: "#FFFFFE"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1652.71 1221.47L1652.71 1059.04L1165.19 1059.04L1165.19 1302.74L1652.92 1302.71L1652.92 1221.47L1652.71 1221.47Z",
    fill: "#EFEFEF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1644.63 1229.76L1644.42 1221.47L1644.42 1067.32L1173.48 1067.32L1173.48 1294.46L1644.63 1294.43L1644.63 1229.76ZM1652.71 1050.75L1661 1050.75L1661 1213.19L1661.2 1213.19L1661.2 1311L1156.91 1311.03L1156.91 1050.75L1652.71 1050.75Z",
    fill: "#FFFFFE"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 84.0306L840.18 84.0306L840.18 246.503L1002.68 246.503L1002.68 84.0306Z",
    fill: "#DCDCDC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 571.448L840.18 571.448L840.18 896.392L1165.19 896.392L1165.19 571.448L1002.68 571.448Z",
    fill: "#DCDCDC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.91 579.733L848.466 579.733L848.466 888.107L1156.91 888.107L1156.91 579.733ZM1173.48 563.162L831.893 563.162L831.893 904.677L1173.48 904.677L1173.48 563.162Z",
    fill: "#FFFFFE"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 896.392L840.179 896.392L840.179 1058.86L1165.19 1058.86L1165.19 896.392L1002.68 896.392Z",
    fill: "#EFEFEF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.91 904.677L848.466 904.677L848.466 1050.58L1156.91 1050.58L1156.91 904.677ZM1173.48 888.107L831.893 888.107L831.893 1067.15L1173.48 1067.15L1173.48 888.107Z",
    fill: "#FFFFFE"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 850.241C1066.84 850.241 1119.03 798.057 1119.03 733.917C1119.03 669.776 1066.84 617.596 1002.68 617.596C938.535 617.596 886.341 669.776 886.341 733.917C886.341 798.057 938.535 850.24 1002.68 850.241ZM1002.68 610.968C1070.49 610.968 1125.66 666.121 1125.66 733.917C1125.66 801.713 1070.49 856.869 1002.68 856.869C934.875 856.869 879.711 801.713 879.711 733.917C879.711 666.121 934.875 610.968 1002.68 610.968Z",
    fill: "#FFFFFE"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 833.935C1057.85 833.935 1102.72 789.066 1102.72 733.917C1102.72 678.767 1057.85 633.901 1002.68 633.901C947.524 633.901 902.646 678.767 902.646 733.917C902.646 789.066 947.524 833.935 1002.68 833.935ZM1002.68 627.273C1061.5 627.273 1109.35 675.112 1109.35 733.917C1109.35 792.722 1061.5 840.563 1002.68 840.563C943.868 840.563 896.016 792.722 896.016 733.917C896.016 675.112 943.868 627.273 1002.68 627.273Z",
    fill: "#FFFFFE"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 817.63C1048.86 817.63 1086.41 780.078 1086.41 733.917C1086.41 687.758 1048.86 650.207 1002.68 650.207C956.514 650.207 918.954 687.758 918.954 733.917C918.954 780.078 956.514 817.63 1002.68 817.63ZM1002.68 643.579C1052.51 643.579 1093.04 684.103 1093.04 733.917C1093.04 783.734 1052.51 824.258 1002.68 824.258C952.861 824.258 912.325 783.734 912.325 733.917C912.325 684.103 952.861 643.579 1002.68 643.579Z",
    fill: "#FFFFFE"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 801.328C1039.86 801.328 1070.11 771.087 1070.11 733.92C1070.11 696.753 1039.86 666.512 1002.68 666.512C965.506 666.512 935.263 696.753 935.263 733.92C935.263 771.087 965.506 801.328 1002.68 801.328ZM1002.68 659.884C1043.52 659.884 1076.74 693.097 1076.74 733.92C1076.74 774.743 1043.52 807.956 1002.68 807.956C961.854 807.956 928.633 774.743 928.633 733.92C928.633 693.097 961.854 659.884 1002.68 659.884Z",
    fill: "#FFFFFE"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 785.023C1030.87 785.023 1053.8 762.096 1053.8 733.92C1053.8 705.74 1030.87 682.817 1002.68 682.817C974.499 682.817 951.571 705.74 951.571 733.92C951.571 762.096 974.499 785.023 1002.68 785.023ZM1002.68 676.189C1034.53 676.189 1060.43 702.085 1060.43 733.92C1060.43 765.752 1034.53 791.651 1002.68 791.651C970.847 791.651 944.942 765.752 944.942 733.92C944.942 702.085 970.847 676.189 1002.68 676.189Z",
    fill: "#FFFFFE"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 768.718C1021.88 768.718 1037.49 753.105 1037.49 733.92C1037.49 714.732 1021.88 699.122 1002.68 699.122C983.492 699.122 967.88 714.732 967.88 733.92C967.88 753.105 983.492 768.718 1002.68 768.718ZM1002.68 692.494C1025.53 692.494 1044.12 711.076 1044.12 733.92C1044.12 756.761 1025.53 775.346 1002.68 775.346C979.839 775.346 961.25 756.761 961.25 733.92C961.25 711.076 979.839 692.494 1002.68 692.494Z",
    fill: "#FFFFFE"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 752.413C1012.88 752.413 1021.18 744.118 1021.18 733.92C1021.18 723.723 1012.88 715.428 1002.68 715.428C992.485 715.428 984.188 723.723 984.188 733.92C984.188 744.117 992.485 752.413 1002.68 752.413ZM1002.68 708.799C1016.54 708.799 1027.81 720.067 1027.81 733.92C1027.81 747.773 1016.54 759.041 1002.68 759.041C988.829 759.041 977.559 747.773 977.559 733.92C977.559 720.067 988.829 708.799 1002.68 708.799Z",
    fill: "#FFFFFE"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1490.2 408.975L1165.19 408.975L1165.19 733.92L1490.2 733.92L1490.2 408.975Z",
    fill: "#DCDCDC"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.7 84.0307C1237.95 84.0307 1165.19 156.771 1165.19 246.503L1165.19 733.92L1490.2 733.92L1490.2 246.503C1490.2 156.771 1417.45 84.0307 1327.7 84.0307Z",
    fill: "#FFF9F5"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1481.91 725.635L1481.91 246.5C1481.91 161.484 1412.73 92.3159 1327.7 92.3159C1242.66 92.3159 1173.48 161.484 1173.48 246.5L1173.48 725.635L1481.91 725.635ZM1327.7 75.7455C1421.87 75.7455 1498.49 152.344 1498.49 246.5L1498.49 742.205L1156.91 742.205L1156.91 246.5C1156.91 152.344 1233.52 75.7455 1327.7 75.7455Z",
    fill: "#FFFFFE"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1083.94 490.21L1002.68 490.21L1002.68 571.444L1083.94 571.444L1083.94 490.21Z",
    fill: "#FFF9F5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.65 498.492L1010.97 498.492L1010.97 563.159L1075.65 563.159L1075.65 498.492ZM1092.23 481.921L994.398 481.921L994.398 579.729L1092.23 579.729L1092.23 481.921Z",
    fill: "#FFFFFE"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1043.31 514.853C1034.49 514.853 1027.33 522.005 1027.33 530.827C1027.33 539.649 1034.49 546.801 1043.31 546.801C1052.13 546.801 1059.29 539.649 1059.29 530.827C1059.29 522.005 1052.13 514.853 1043.31 514.853Z",
    fill: "#DCDCDC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1165.19 490.21L1083.94 490.21L1083.94 571.444L1165.19 571.444L1165.19 490.21Z",
    fill: "#F9C756"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.9 498.492L1092.23 498.492L1092.23 563.159L1156.9 563.159L1156.9 498.492ZM1173.48 481.921L1075.65 481.921L1075.65 579.729L1173.48 579.729L1173.48 481.921Z",
    fill: "#FFFFFE"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.56 514.853C1115.74 514.853 1108.59 522.005 1108.59 530.827C1108.59 539.649 1115.74 546.801 1124.56 546.801C1133.38 546.801 1140.54 539.649 1140.54 530.827C1140.54 522.005 1133.38 514.853 1124.56 514.853Z",
    fill: "#EFEFEF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 490.21L921.431 490.21L921.431 571.444L1002.68 571.444L1002.68 490.21Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.395 498.492L929.717 498.492L929.717 563.159L994.395 563.159L994.395 498.492ZM1010.97 481.921L913.144 481.921L913.144 579.729L1010.97 579.729L1010.97 481.921Z",
    fill: "#FFFFFE"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M962.056 514.853C953.232 514.853 946.082 522.005 946.082 530.827C946.082 539.649 953.232 546.801 962.056 546.801C970.88 546.801 978.033 539.649 978.033 530.827C978.033 522.005 970.88 514.853 962.056 514.853Z",
    fill: "#DCDCDC"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.43 490.21L840.18 490.21L840.18 571.444L921.43 571.444L921.43 490.21Z",
    fill: "#EFEFEF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.144 498.492L848.466 498.492L848.466 563.159L913.144 563.159L913.144 498.492ZM929.717 481.921L831.893 481.921L831.893 579.729L929.717 579.729L929.717 481.921Z",
    fill: "#FFFFFE"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M880.805 514.853C871.981 514.853 864.828 522.005 864.828 530.827C864.828 539.649 871.981 546.801 880.805 546.801C889.629 546.801 896.782 539.649 896.782 530.827C896.782 522.005 889.629 514.853 880.805 514.853Z",
    fill: "#DCDCDC"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.7 733.92L1327.7 815.155C1327.7 860.02 1291.32 896.392 1246.44 896.392C1201.57 896.392 1165.19 860.02 1165.19 815.154L1165.19 733.92L1327.7 733.92Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.41 742.205L1173.48 742.205L1173.48 815.158C1173.48 855.381 1206.21 888.107 1246.44 888.107C1286.68 888.107 1319.41 855.381 1319.41 815.158L1319.41 742.205ZM1156.91 725.635L1335.98 725.635L1335.98 815.158C1335.98 864.518 1295.82 904.677 1246.44 904.677C1197.07 904.677 1156.91 864.518 1156.91 815.158L1156.91 725.635Z",
    fill: "#FFFFFE"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.7 246.321L848.546 246.321L848.546 408.793L1327.7 408.793L1327.7 246.321Z",
    fill: "#F7F5F5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.41 254.603L856.83 254.603L856.83 400.508L1319.41 400.508L1319.41 254.603ZM1335.98 238.032L840.256 238.032L840.256 417.078L1335.98 417.078L1335.98 238.032Z",
    fill: "#FFFFFE"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1165.19 1058.86L1165.19 896.392L1002.68 896.392C1002.68 986.124 1075.44 1058.86 1165.19 1058.86Z",
    fill: "#FFF9F5"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.91 904.677L1011.19 904.677C1015.37 983.111 1078.46 1046.18 1156.91 1050.36L1156.91 904.677ZM994.398 888.107L1173.48 888.107L1173.48 1067.15L1165.19 1067.15C1071.01 1067.15 994.398 990.548 994.398 896.392L994.398 888.107Z",
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1401_1533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1165,
    y: 1059,
    width: 326,
    height: 163
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.7 1059.03L1165.19 1059.03L1165.19 1221.51L1490.2 1221.51L1490.2 1059.03L1327.7 1059.03Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1401_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.56 1183.51C1399.71 1183.51 1451.91 1131.33 1451.91 1067.19C1451.91 1003.05 1399.71 950.866 1335.56 950.866C1271.41 950.866 1219.21 1003.05 1219.21 1067.19C1219.21 1131.33 1271.41 1183.51 1335.56 1183.51ZM1335.56 944.237C1403.37 944.237 1458.54 999.394 1458.54 1067.19C1458.54 1134.99 1403.37 1190.14 1335.56 1190.14C1267.75 1190.14 1212.58 1134.99 1212.58 1067.19C1212.58 999.394 1267.75 944.237 1335.56 944.237Z",
    fill: "#D9264B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.56 1167.21C1390.72 1167.21 1435.6 1122.34 1435.6 1067.19C1435.6 1012.04 1390.72 967.171 1335.56 967.171C1280.4 967.171 1235.52 1012.04 1235.52 1067.19C1235.52 1122.34 1280.4 1167.21 1335.56 1167.21ZM1335.56 960.543C1394.38 960.543 1442.23 1008.38 1442.23 1067.19C1442.23 1125.99 1394.38 1173.84 1335.56 1173.84C1276.74 1173.84 1228.89 1125.99 1228.89 1067.19C1228.89 1008.38 1276.74 960.543 1335.56 960.543Z",
    fill: "#DC3F60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.56 1150.9C1381.73 1150.9 1419.29 1113.35 1419.29 1067.19C1419.29 1021.03 1381.73 983.476 1335.56 983.476C1289.39 983.476 1251.83 1021.03 1251.83 1067.19C1251.83 1113.35 1289.39 1150.9 1335.56 1150.9ZM1335.56 976.848C1385.38 976.848 1425.92 1017.38 1425.92 1067.19C1425.92 1117 1385.38 1157.53 1335.56 1157.53C1285.74 1157.53 1245.2 1117 1245.2 1067.19C1245.2 1017.38 1285.74 976.848 1335.56 976.848Z",
    fill: "#DC3F60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.56 1134.6C1372.74 1134.6 1402.98 1104.36 1402.98 1067.19C1402.98 1030.02 1372.74 999.781 1335.56 999.781C1298.38 999.781 1268.14 1030.02 1268.14 1067.19C1268.14 1104.36 1298.38 1134.6 1335.56 1134.6ZM1335.56 993.153C1376.39 993.153 1409.61 1026.37 1409.61 1067.19C1409.61 1108.02 1376.39 1141.23 1335.56 1141.23C1294.73 1141.23 1261.51 1108.02 1261.51 1067.19C1261.51 1026.37 1294.73 993.153 1335.56 993.153Z",
    fill: "#D9264B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.56 1118.29C1363.75 1118.29 1386.67 1095.37 1386.67 1067.19C1386.67 1039.01 1363.75 1016.09 1335.56 1016.09C1307.38 1016.09 1284.45 1039.01 1284.45 1067.19C1284.45 1095.37 1307.38 1118.29 1335.56 1118.29ZM1335.56 1009.46C1367.4 1009.46 1393.3 1035.35 1393.3 1067.19C1393.3 1099.02 1367.4 1124.92 1335.56 1124.92C1303.72 1124.92 1277.82 1099.02 1277.82 1067.19C1277.82 1035.35 1303.72 1009.46 1335.56 1009.46Z",
    fill: "#FFFFFE"
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M831.893 896.392L848.466 896.392L848.466 942.262L902.636 942.262L902.636 996.421L956.802 996.421L956.802 1050.58L1002.68 1050.58L1002.68 1067.15L940.228 1067.15L940.228 1012.99L886.062 1012.99L886.062 958.833L831.893 958.833L831.893 896.392Z",
    fill: "#FFFFFE"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.398 2.79295L1010.97 2.79296L1010.97 48.6663L1065.14 48.6663L1065.14 102.825L1119.31 102.825L1119.31 156.977L1186.99 156.977L1186.99 173.547L1102.73 173.547L1102.73 119.395L1048.57 119.395L1048.57 65.2366L994.398 65.2366L994.398 2.79295Z",
    fill: "#FFFFFE"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 185.499C971 187.983 969.209 189.999 967 189.999C964.792 189.999 963 187.983 963 185.499C963 183.015 964.792 180.999 967 180.999C969.209 180.999 971 183.015 971 185.499Z",
    fill: "#08569D"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 185.499C989 187.983 987.209 189.999 985 189.999C982.792 189.999 981 187.983 981 185.499C981 183.015 982.792 180.999 985 180.999C987.209 180.999 989 183.015 989 185.499Z",
    fill: "#08569D"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 222.499C971 224.983 969.209 226.999 967 226.999C964.792 226.999 963 224.983 963 222.499C963 220.015 964.792 217.999 967 217.999C969.209 217.999 971 220.015 971 222.499Z",
    fill: "#08569D"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 222.499C989 224.983 987.209 226.999 985 226.999C982.792 226.999 981 224.983 981 222.499C981 220.015 982.792 217.999 985 217.999C987.209 217.999 989 220.015 989 222.499Z",
    fill: "#08569D"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 240.499C971 242.986 969.209 244.999 967 244.999C964.792 244.999 963 242.986 963 240.499C963 238.015 964.792 235.999 967 235.999C969.209 235.999 971 238.015 971 240.499Z",
    fill: "#08569D"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 240.499C989 242.986 987.209 244.999 985 244.999C982.792 244.999 981 242.986 981 240.499C981 238.015 982.792 235.999 985 235.999C987.209 235.999 989 238.015 989 240.499Z",
    fill: "#08569D"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 203.999C971 206.21 969.209 207.999 967 207.999C964.792 207.999 963 206.21 963 203.999C963 201.791 964.792 199.999 967 199.999C969.209 199.999 971 201.791 971 203.999Z",
    fill: "#08569D"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 203.999C989 206.21 987.209 207.999 985 207.999C982.792 207.999 981 206.21 981 203.999C981 201.791 982.792 199.999 985 199.999C987.209 199.999 989 201.791 989 203.999Z",
    fill: "#08569D"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 167.499C971 169.983 969.209 171.999 967 171.999C964.792 171.999 963 169.983 963 167.499C963 165.015 964.792 162.999 967 162.999C969.209 162.999 971 165.015 971 167.499Z",
    fill: "#08569D"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 167.499C989 169.983 987.209 171.999 985 171.999C982.792 171.999 981 169.983 981 167.499C981 165.015 982.792 162.999 985 162.999C987.209 162.999 989 165.015 989 167.499Z",
    fill: "#08569D"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 149.499C971 151.983 969.209 153.999 967 153.999C964.792 153.999 963 151.983 963 149.499C963 147.015 964.792 144.999 967 144.999C969.209 144.999 971 147.015 971 149.499Z",
    fill: "#08569D"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 149.499C989 151.983 987.209 153.999 985 153.999C982.792 153.999 981 151.983 981 149.499C981 147.015 982.792 144.999 985 144.999C987.209 144.999 989 147.015 989 149.499Z",
    fill: "#08569D"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.151 1088.96C876.151 1092.29 873.446 1095 870.105 1095C866.767 1095 864.062 1092.29 864.062 1088.96C864.062 1085.62 866.767 1082.91 870.105 1082.91C873.446 1082.91 876.151 1085.62 876.151 1088.96Z",
    fill: "#08569D"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.814 1088.96C901.814 1092.29 899.109 1095 895.768 1095C892.43 1095 889.725 1092.29 889.725 1088.96C889.725 1085.62 892.43 1082.91 895.768 1082.91C899.109 1082.91 901.814 1085.62 901.814 1088.96Z",
    fill: "#08569D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.477 1088.96C927.477 1092.29 924.772 1095 921.434 1095C918.093 1095 915.388 1092.29 915.388 1088.96C915.388 1085.62 918.093 1082.91 921.434 1082.91C924.772 1082.91 927.477 1085.62 927.477 1088.96Z",
    fill: "#08569D"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.139 1088.96C953.139 1092.29 950.434 1095 947.096 1095C943.755 1095 941.05 1092.29 941.05 1088.96C941.05 1085.62 943.755 1082.91 947.096 1082.91C950.434 1082.91 953.139 1085.62 953.139 1088.96Z",
    fill: "#08569D"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.805 1088.96C978.805 1092.29 976.097 1095 972.759 1095C969.418 1095 966.713 1092.29 966.713 1088.96C966.713 1085.62 969.418 1082.91 972.759 1082.91C976.097 1082.91 978.805 1085.62 978.805 1088.96Z",
    fill: "#08569D"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.151 1140.27C876.151 1143.61 873.446 1146.32 870.105 1146.32C866.767 1146.32 864.062 1143.61 864.062 1140.27C864.062 1136.93 866.767 1134.23 870.105 1134.23C873.446 1134.23 876.151 1136.93 876.151 1140.27Z",
    fill: "#FFFFFE"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.814 1140.27C901.814 1143.61 899.109 1146.32 895.768 1146.32C892.43 1146.32 889.725 1143.61 889.725 1140.27C889.725 1136.93 892.43 1134.23 895.768 1134.23C899.109 1134.23 901.814 1136.93 901.814 1140.27Z",
    fill: "#FFFFFE"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.477 1140.27C927.477 1143.61 924.772 1146.32 921.434 1146.32C918.093 1146.32 915.388 1143.61 915.388 1140.27C915.388 1136.93 918.093 1134.23 921.434 1134.23C924.772 1134.23 927.477 1136.93 927.477 1140.27Z",
    fill: "#08569D"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.139 1140.27C953.139 1143.61 950.434 1146.32 947.096 1146.32C943.755 1146.32 941.05 1143.61 941.05 1140.27C941.05 1136.93 943.755 1134.23 947.096 1134.23C950.434 1134.23 953.139 1136.93 953.139 1140.27Z",
    fill: "#08569D"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.805 1140.27C978.805 1143.61 976.097 1146.32 972.759 1146.32C969.418 1146.32 966.713 1143.61 966.713 1140.27C966.713 1136.93 969.418 1134.23 972.759 1134.23C976.097 1134.23 978.805 1136.93 978.805 1140.27Z",
    fill: "#08569D"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.151 1191.59C876.151 1194.92 873.446 1197.63 870.105 1197.63C866.767 1197.63 864.062 1194.92 864.062 1191.59C864.062 1188.25 866.767 1185.54 870.105 1185.54C873.446 1185.54 876.151 1188.25 876.151 1191.59Z",
    fill: "#FFFFFE"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.814 1191.59C901.814 1194.92 899.109 1197.63 895.768 1197.63C892.43 1197.63 889.725 1194.92 889.725 1191.59C889.725 1188.25 892.43 1185.54 895.768 1185.54C899.109 1185.54 901.814 1188.25 901.814 1191.59Z",
    fill: "#FFFFFE"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.477 1191.59C927.477 1194.92 924.772 1197.63 921.434 1197.63C918.093 1197.63 915.388 1194.92 915.388 1191.59C915.388 1188.25 918.093 1185.54 921.434 1185.54C924.772 1185.54 927.477 1188.25 927.477 1191.59Z",
    fill: "#FFFFFE"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.139 1191.59C953.139 1194.92 950.434 1197.63 947.096 1197.63C943.755 1197.63 941.05 1194.92 941.05 1191.59C941.05 1188.25 943.755 1185.54 947.096 1185.54C950.434 1185.54 953.139 1188.25 953.139 1191.59Z",
    fill: "#FFFFFE"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.805 1191.59C978.805 1194.92 976.097 1197.63 972.759 1197.63C969.418 1197.63 966.713 1194.92 966.713 1191.59C966.713 1188.25 969.418 1185.54 972.759 1185.54C976.097 1185.54 978.805 1188.25 978.805 1191.59Z",
    fill: "#FFFFFE"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.151 1165.93C876.151 1169.27 873.446 1171.97 870.105 1171.97C866.767 1171.97 864.062 1169.27 864.062 1165.93C864.062 1162.59 866.767 1159.88 870.105 1159.88C873.446 1159.88 876.151 1162.59 876.151 1165.93Z",
    fill: "#FFFFFE"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.814 1165.93C901.814 1169.27 899.109 1171.97 895.768 1171.97C892.43 1171.97 889.725 1169.27 889.725 1165.93C889.725 1162.59 892.43 1159.88 895.768 1159.88C899.109 1159.88 901.814 1162.59 901.814 1165.93Z",
    fill: "#FFFFFE"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.477 1165.93C927.477 1169.27 924.772 1171.97 921.434 1171.97C918.093 1171.97 915.388 1169.27 915.388 1165.93C915.388 1162.59 918.093 1159.88 921.434 1159.88C924.772 1159.88 927.477 1162.59 927.477 1165.93Z",
    fill: "#FFFFFE"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.139 1165.93C953.139 1169.27 950.434 1171.97 947.096 1171.97C943.755 1171.97 941.05 1169.27 941.05 1165.93C941.05 1162.59 943.755 1159.88 947.096 1159.88C950.434 1159.88 953.139 1162.59 953.139 1165.93Z",
    fill: "#FFFFFE"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.805 1165.93C978.805 1169.27 976.097 1171.97 972.759 1171.97C969.418 1171.97 966.713 1169.27 966.713 1165.93C966.713 1162.59 969.418 1159.88 972.759 1159.88C976.097 1159.88 978.805 1162.59 978.805 1165.93Z",
    fill: "#FFFFFE"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.151 1114.61C876.151 1117.95 873.446 1120.66 870.105 1120.66C866.767 1120.66 864.062 1117.95 864.062 1114.61C864.062 1111.28 866.767 1108.57 870.105 1108.57C873.446 1108.57 876.151 1111.28 876.151 1114.61Z",
    fill: "#08569D"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.814 1114.61C901.814 1117.95 899.109 1120.66 895.768 1120.66C892.43 1120.66 889.725 1117.95 889.725 1114.61C889.725 1111.28 892.43 1108.57 895.768 1108.57C899.109 1108.57 901.814 1111.28 901.814 1114.61Z",
    fill: "#08569D"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.477 1114.61C927.477 1117.95 924.772 1120.66 921.434 1120.66C918.093 1120.66 915.388 1117.95 915.388 1114.61C915.388 1111.28 918.093 1108.57 921.434 1108.57C924.772 1108.57 927.477 1111.28 927.477 1114.61Z",
    fill: "#08569D"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.139 1114.61C953.139 1117.95 950.434 1120.66 947.096 1120.66C943.755 1120.66 941.05 1117.95 941.05 1114.61C941.05 1111.28 943.755 1108.57 947.096 1108.57C950.434 1108.57 953.139 1111.28 953.139 1114.61Z",
    fill: "#08569D"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.805 1114.61C978.805 1117.95 976.097 1120.66 972.759 1120.66C969.418 1120.66 966.713 1117.95 966.713 1114.61C966.713 1111.28 969.418 1108.57 972.759 1108.57C976.097 1108.57 978.805 1111.28 978.805 1114.61Z",
    fill: "#08569D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1401_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1652.92 1302.61L840.392 1302.61L840.392 2602.39L1652.92 2602.39L1652.92 1302.61Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 1546.5L840.179 1546.5L840.179 1871.45L1002.68 1871.45L1002.68 1546.5Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 1384.03L840.179 1384.03L840.179 1546.5L1002.68 1546.5L1002.68 1384.03Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1490.2 1708.98L1165.19 1708.98L1165.19 2033.92L1490.2 2033.92L1490.2 1708.98Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.69 1384.03C1237.95 1384.03 1165.19 1456.77 1165.19 1546.5L1165.19 2033.92L1490.2 2033.92L1490.2 1546.5C1490.2 1456.77 1417.44 1384.03 1327.69 1384.03Z",
    fill: "#FFF9F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1481.91 2025.63L1481.91 1546.5C1481.91 1461.48 1412.73 1392.32 1327.69 1392.32C1242.66 1392.32 1173.48 1461.48 1173.48 1546.5L1173.48 2025.63L1481.91 2025.63ZM1327.69 1375.75C1421.87 1375.75 1498.49 1452.34 1498.49 1546.5L1498.49 2042.21L1156.91 2042.21L1156.91 1546.5C1156.91 1452.34 1233.52 1375.75 1327.69 1375.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1083.94 1790.21L1002.68 1790.21L1002.68 1871.44L1083.94 1871.44L1083.94 1790.21Z",
    fill: "#FFF9F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.65 1798.49L1010.97 1798.49L1010.97 1863.16L1075.65 1863.16L1075.65 1798.49ZM1092.23 1781.92L994.398 1781.92L994.398 1879.73L1092.23 1879.73L1092.23 1781.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1043.31 1814.85C1034.49 1814.85 1027.33 1822.01 1027.33 1830.83C1027.33 1839.65 1034.49 1846.8 1043.31 1846.8C1052.13 1846.8 1059.29 1839.65 1059.29 1830.83C1059.29 1822.01 1052.13 1814.85 1043.31 1814.85Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1165.19 1790.21L1083.94 1790.21L1083.94 1871.44L1165.19 1871.44L1165.19 1790.21Z",
    fill: "#F9C756"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.9 1798.49L1092.23 1798.49L1092.23 1863.16L1156.9 1863.16L1156.9 1798.49ZM1173.48 1781.92L1075.65 1781.92L1075.65 1879.73L1173.48 1879.73L1173.48 1781.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.56 1814.85C1115.74 1814.85 1108.59 1822.01 1108.59 1830.83C1108.59 1839.65 1115.74 1846.8 1124.56 1846.8C1133.38 1846.8 1140.54 1839.65 1140.54 1830.83C1140.54 1822.01 1133.38 1814.85 1124.56 1814.85Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.68 1790.21L921.43 1790.21L921.43 1871.44L1002.68 1871.44L1002.68 1790.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.394 1798.49L929.717 1798.49L929.717 1863.16L994.394 1863.16L994.394 1798.49ZM1010.97 1781.92L913.143 1781.92L913.143 1879.73L1010.97 1879.73L1010.97 1781.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M962.056 1814.85C953.232 1814.85 946.082 1822.01 946.082 1830.83C946.082 1839.65 953.232 1846.8 962.056 1846.8C970.879 1846.8 978.033 1839.65 978.033 1830.83C978.033 1822.01 970.879 1814.85 962.056 1814.85Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.43 1790.21L840.179 1790.21L840.179 1871.44L921.43 1871.44L921.43 1790.21Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.143 1798.49L848.466 1798.49L848.466 1863.16L913.143 1863.16L913.143 1798.49ZM929.717 1781.92L831.892 1781.92L831.892 1879.73L929.717 1879.73L929.717 1781.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M880.805 1814.85C871.981 1814.85 864.828 1822.01 864.828 1830.83C864.828 1839.65 871.981 1846.8 880.805 1846.8C889.629 1846.8 896.782 1839.65 896.782 1830.83C896.782 1822.01 889.629 1814.85 880.805 1814.85Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.69 1546.32L848.546 1546.32L848.546 1708.79L1327.69 1708.79L1327.69 1546.32Z",
    fill: "#F7F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.41 1554.6L856.829 1554.6L856.829 1700.51L1319.41 1700.51L1319.41 1554.6ZM1335.98 1538.03L840.256 1538.03L840.256 1717.08L1335.98 1717.08L1335.98 1538.03Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.398 1302.79L1010.97 1302.79L1010.97 1348.67L1065.14 1348.67L1065.14 1402.83L1119.31 1402.83L1119.31 1456.98L1186.99 1456.98L1186.99 1473.55L1102.73 1473.55L1102.73 1419.4L1048.57 1419.4L1048.57 1365.24L994.398 1365.24L994.398 1302.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 1485.5C971 1487.98 969.208 1490 967 1490C964.792 1490 963 1487.98 963 1485.5C963 1483.01 964.792 1481 967 1481C969.208 1481 971 1483.01 971 1485.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 1485.5C989 1487.98 987.208 1490 985 1490C982.792 1490 981 1487.98 981 1485.5C981 1483.01 982.792 1481 985 1481C987.208 1481 989 1483.01 989 1485.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 1522.5C971 1524.98 969.208 1527 967 1527C964.792 1527 963 1524.98 963 1522.5C963 1520.01 964.792 1518 967 1518C969.208 1518 971 1520.01 971 1522.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 1522.5C989 1524.98 987.208 1527 985 1527C982.792 1527 981 1524.98 981 1522.5C981 1520.01 982.792 1518 985 1518C987.208 1518 989 1520.01 989 1522.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 1540.5C971 1542.99 969.208 1545 967 1545C964.792 1545 963 1542.99 963 1540.5C963 1538.01 964.792 1536 967 1536C969.208 1536 971 1538.01 971 1540.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 1540.5C989 1542.99 987.208 1545 985 1545C982.792 1545 981 1542.99 981 1540.5C981 1538.01 982.792 1536 985 1536C987.208 1536 989 1538.01 989 1540.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 1504C971 1506.21 969.208 1508 967 1508C964.792 1508 963 1506.21 963 1504C963 1501.79 964.792 1500 967 1500C969.208 1500 971 1501.79 971 1504Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 1504C989 1506.21 987.208 1508 985 1508C982.792 1508 981 1506.21 981 1504C981 1501.79 982.792 1500 985 1500C987.208 1500 989 1501.79 989 1504Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 1467.5C971 1469.98 969.208 1472 967 1472C964.792 1472 963 1469.98 963 1467.5C963 1465.01 964.792 1463 967 1463C969.208 1463 971 1465.01 971 1467.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 1467.5C989 1469.98 987.208 1472 985 1472C982.792 1472 981 1469.98 981 1467.5C981 1465.01 982.792 1463 985 1463C987.208 1463 989 1465.01 989 1467.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 1449.5C971 1451.98 969.208 1454 967 1454C964.792 1454 963 1451.98 963 1449.5C963 1447.01 964.792 1445 967 1445C969.208 1445 971 1447.01 971 1449.5Z",
    fill: "#08569D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989 1449.5C989 1451.98 987.208 1454 985 1454C982.792 1454 981 1451.98 981 1449.5C981 1447.01 982.792 1445 985 1445C987.208 1445 989 1447.01 989 1449.5Z",
    fill: "#08569D"
  }))), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M236.634 198.5C237.019 197.833 237.981 197.833 238.366 198.5L242.263 205.25C242.648 205.917 242.167 206.75 241.397 206.75H233.603C232.833 206.75 232.352 205.917 232.737 205.25L236.634 198.5Z",
    fill: "#265CA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1832,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1401_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 832,
    height: 1319,
    fill: "white",
    transform: "translate(832 2612) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1401_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 832,
    height: 1319,
    fill: "white",
    transform: "translate(1662 1312) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1401_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 832,
    height: 1319,
    fill: "white",
    transform: "translate(1662 2612) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.60a28144fcd39442bdf05109147258b0.svg";
export { ForwardRef as ReactComponent };